// Emoji data from emojibase-data 17.0.0 (github.com/milesj/emojibase), with
// Slack's names from emoji-data (github.com/iamcal/emoji-data), both MIT
// licensed; their notices are in public/third-party-licenses.txt.
// Generated by scripts/emoji-data.mjs; do not edit. Each emoji is [name,
// glyph, words search finds it by, other names], by Slack's names.

export const emojiData: [string, [string, string, string, string?][]][] = [
  ["people", [
    ["grinning","😀","face cheerful cheery grin happy laugh nice smile smiling teeth"],
    ["smiley","😃","grinning face with big eyes awesome grin happy mouth open smile smiling teeth yay"],
    ["smile","😄","grinning face with smiling eyes eye grin happy laugh lol mouth open"],
    ["grin","😁","beaming face with smiling eyes eye grinning happy nice smile teeth"],
    ["laughing","😆","grinning squinting face closed eyes haha hahaha happy laugh lol mouth open rofl smile smiling","satisfied"],
    ["sweat_smile","😅","grinning face with sweat cold dejected excited mouth nervous open smile smiling stress stressed"],
    ["rolling_on_the_floor_laughing","🤣","rolling on the floor laughing crying face funny haha happy hehe hilarious joy laugh lmao lol rofl roflmao tear"],
    ["joy","😂","face with tears of crying feels funny haha happy hehe hilarious laugh lmao lol rofl roflmao tear"],
    ["slightly_smiling_face","🙂","slightly smiling face happy smile"],
    ["upside_down_face","🙃","upside-down face hehe smile"],
    ["melting_face","🫠","melting face disappear dissolve embarrassed haha heat hot liquid lol melt sarcasm sarcastic"],
    ["wink","😉","winking face flirt heartbreaker sexy slide tease winks"],
    ["blush","😊","smiling face with eyes eye glad satisfied smile"],
    ["innocent","😇","smiling face with halo angel angelic angels blessed fairy fairytale fantasy happy peaceful smile spirit tale"],
    ["smiling_face_with_3_hearts","🥰","smiling face with hearts 3 adore crush heart ily love romance smile you"],
    ["heart_eyes","😍","smiling face with heart-eyes 143 bae eye feels hearts ily kisses love romance romantic smile xoxo"],
    ["star-struck","🤩","excited eyes face grinning smile star starry-eyed wow","grinning_face_with_star_eyes"],
    ["kissing_heart","😘","face blowing a kiss adorbs bae flirt heart ily love lover miss muah romantic smooch xoxo you"],
    ["kissing","😗","face 143 date dating flirt ily kiss love smooch smooches xoxo you"],
    ["relaxed","☺️","smiling face happy outlined smile"],
    ["kissing_closed_eyes","😚","kissing face with closed eyes 143 bae blush date dating eye flirt ily kisses smooches xoxo"],
    ["kissing_smiling_eyes","😙","kissing face with smiling eyes 143 closed date dating eye flirt ily kiss kisses love night smile"],
    ["smiling_face_with_tear","🥲","smiling face with tear glad grateful happy joy pain proud relieved smile smiley touched"],
    ["yum","😋","face savoring food delicious eat full hungry savor smile smiling tasty um yummy"],
    ["stuck_out_tongue","😛","face with tongue awesome cool nice party stuck-out sweet"],
    ["stuck_out_tongue_winking_eye","😜","winking face with tongue crazy epic eye funny joke loopy nutty party stuck-out wacky weirdo wink yolo"],
    ["zany_face","🤪","zany face crazy eye eyes goofy large small","grinning_face_with_one_large_and_one_small_eye"],
    ["stuck_out_tongue_closed_eyes","😝","squinting face with tongue closed eye eyes gross horrible omg stuck-out taste whatever yolo"],
    ["money_mouth_face","🤑","money-mouth face money mouth paid"],
    ["hugging_face","🤗","smiling face with open hands hug hugging"],
    ["face_with_hand_over_mouth","🤭","face with hand over mouth giggle giggling oops realization secret shock sudden surprise whoops","smiling_face_with_smiling_eyes_and_hand_covering_mouth"],
    ["face_with_open_eyes_and_hand_over_mouth","🫢","face with open eyes and hand over mouth amazement awe disbelief embarrass gasp omg quiet scared shock surprise"],
    ["face_with_peeking_eye","🫣","face with peeking eye captivated embarrass hide hiding peek peep scared shy stare"],
    ["shushing_face","🤫","shushing face quiet shh shush","face_with_finger_covering_closed_lips"],
    ["thinking_face","🤔","thinking face chin consider hmm ponder pondering wondering"],
    ["saluting_face","🫡","saluting face good luck ma’am ok respect salute sir troops yes"],
    ["zipper_mouth_face","🤐","zipper-mouth face keep mouth quiet secret shut zip zipper"],
    ["face_with_raised_eyebrow","🤨","face with raised eyebrow disapproval disbelief distrust emoji hmm mild skeptic skeptical skepticism surprise what","face_with_one_eyebrow_raised"],
    ["neutral_face","😐","neutral face awkward blank deadpan expressionless fine jealous meh oh shade straight unamused unhappy unimpressed whatever"],
    ["expressionless","😑","face awkward dead fine inexpressive jealous meh not oh omg straight uh unhappy unimpressed whatever"],
    ["no_mouth","😶","face without mouth awkward blank expressionless mouthless mute quiet secret silence silent speechless"],
    ["dotted_line_face","🫥","dotted line face depressed disappear hidden hide introvert invisible meh whatever wtv"],
    ["face_in_clouds","😶‍🌫️","face in clouds absentminded fog head"],
    ["smirk","😏","smirking face boss dapper flirt homie kidding leer shade slick sly smug snicker suave suspicious swag"],
    ["unamused","😒","face ... bored fine jealous jel jelly pissed smh ugh uhh unhappy weird whatever"],
    ["face_with_rolling_eyes","🙄","face with rolling eyes eyeroll shade ugh whatever"],
    ["grimacing","😬","face awk awkward dentist grimace grinning smile smiling"],
    ["face_exhaling","😮‍💨","face exhaling blow blowing exhale exhausted gasp groan relief sigh smiley smoke whisper whistle"],
    ["lying_face","🤥","lying face liar lie pinocchio"],
    ["shaking_face","🫨","shaking face crazy daze earthquake omg panic shock surprise vibrate whoa wow"],
    ["head_shaking_horizontally","🙂‍↔️","head shaking horizontally no shake"],
    ["head_shaking_vertically","🙂‍↕️","head shaking vertically nod yes"],
    ["relieved","😌","face calm peace relief zen"],
    ["pensive","😔","face awful bored dejected died disappointed losing lost sad sucks"],
    ["sleepy","😪","face crying good night sad sleep sleeping tired"],
    ["drooling_face","🤤","drooling face"],
    ["sleeping","😴","face bed bedtime good goodnight nap night sleep tired whatever yawn zzz"],
    ["face_with_bags_under_eyes","🫩","face with bags under eyes bored exhausted fatigued late sleepy tired weary"],
    ["mask","😷","face with medical cold dentist dermatologist doctor dr germs medicine sick"],
    ["face_with_thermometer","🤒","face with thermometer ill sick"],
    ["face_with_head_bandage","🤕","face with head-bandage bandage hurt injury ouch"],
    ["nauseated_face","🤢","nauseated face gross nasty sick vomit"],
    ["face_vomiting","🤮","face vomiting barf ew gross puke sick spew throw up vomit","face_with_open_mouth_vomiting"],
    ["sneezing_face","🤧","sneezing face fever flu gesundheit sick sneeze"],
    ["hot_face","🥵","hot face dying feverish heat panting red-faced stroke sweating tongue"],
    ["cold_face","🥶","cold face blue blue-faced freezing frostbite icicles subzero teeth"],
    ["woozy_face","🥴","woozy face dizzy drunk eyes intoxicated mouth tipsy uneven wavy"],
    ["dizzy_face","😵","face with crossed-out eyes dead dizzy feels knocked out sick tired"],
    ["face_with_spiral_eyes","😵‍💫","face with spiral eyes confused dizzy hypnotized omg smiley trouble whoa woah woozy"],
    ["exploding_head","🤯","exploding head blown explode mind mindblown no shocked way","shocked_face_with_exploding_head"],
    ["face_with_cowboy_hat","🤠","cowboy hat face cowgirl"],
    ["partying_face","🥳","partying face bday birthday celebrate celebration excited happy hat hooray horn party"],
    ["disguised_face","🥸","disguised face disguise eyebrow glasses incognito moustache mustache nose person spy tache tash"],
    ["sunglasses","😎","smiling face with awesome beach bright bro chilling cool rad relaxed shades slay smile style swag win"],
    ["nerd_face","🤓","nerd face brainy clever expert geek gifted glasses intelligent smart"],
    ["face_with_monocle","🧐","face with monocle classy fancy rich stuffy wealthy"],
    ["confused","😕","face befuddled confusing dunno frown hm meh not sad sorry sure"],
    ["face_with_diagonal_mouth","🫤","face with diagonal mouth confused confusion disappointed doubt doubtful frustrated frustration meh skeptical unsure whatever wtv"],
    ["worried","😟","face anxious butterflies nerves nervous sad stress stressed surprised worry"],
    ["slightly_frowning_face","🙁","slightly frowning face frown sad"],
    ["white_frowning_face","☹️","frowning face frown sad"],
    ["open_mouth","😮","face with open mouth believe forgot omg shocked surprised sympathy unbelievable unreal whoa wow you"],
    ["hushed","😯","face epic omg stunned surprised whoa woah"],
    ["astonished","😲","face cost no omg shocked totally way"],
    ["flushed","😳","face amazed awkward crazy dazed dead disbelief embarrassed geez heat hot impressed jeez what wow"],
    ["pleading_face","🥺","pleading face begging big eyes mercy not please pretty puppy sad why"],
    ["face_holding_back_tears","🥹","face holding back tears admiration aww cry embarrassed feelings grateful gratitude joy please proud resist sad"],
    ["frowning","😦","face with open mouth caught frown guard scared scary surprise what wow"],
    ["anguished","😧","face forgot scared scary stressed surprise unhappy what wow"],
    ["fearful","😨","face afraid anxious blame fear scared worried"],
    ["cold_sweat","😰","anxious face with sweat blue cold eek mouth nervous open rushed scared yikes"],
    ["disappointed_relieved","😥","sad but relieved face anxious call close complicated disappointed not sweat time whew"],
    ["cry","😢","crying face awful feels miss sad tear triste unhappy"],
    ["sob","😭","loudly crying face bawling cry sad tear tears unhappy"],
    ["scream","😱","face screaming in fear epic fearful munch scared screamer shocked surprised woah"],
    ["confounded","😖","face annoyed confused cringe distraught feels frustrated mad sad"],
    ["persevere","😣","persevering face concentrate concentration focus headache"],
    ["disappointed","😞","face awful blame dejected fail losing sad unhappy"],
    ["sweat","😓","downcast face with close cold feels headache nervous sad scared yikes"],
    ["weary","😩","face crying fail feels hungry mad nooo sad sleepy tired unhappy"],
    ["tired_face","😫","tired face cost feels nap sad sneeze"],
    ["yawning_face","🥱","yawning face bedtime bored goodnight nap night sleep sleepy tired whatever yawn zzz"],
    ["triumph","😤","face with steam from nose anger angry feels fume fuming furious fury mad unhappy won"],
    ["rage","😡","enraged face anger angry feels mad maddening pouting red shade unhappy upset"],
    ["angry","😠","face anger blame feels frustrated mad maddening rage shade unhappy upset"],
    ["face_with_symbols_on_mouth","🤬","face with symbols on mouth censor cursing cussing mad pissed swearing","serious_face_with_symbols_covering_mouth"],
    ["smiling_imp","😈","smiling face with horns demon devil evil fairy fairytale fantasy purple shade smile tale"],
    ["imp","👿","angry face with horns demon devil evil fairy fairytale fantasy mischievous purple shade tale"],
    ["skull","💀","body dead death face fairy fairytale i’m lmao monster tale yolo"],
    ["skull_and_crossbones","☠️","skull and crossbones bone dead death face monster"],
    ["hankey","💩","pile of poo bs comic doo dung face fml monster smelly smh stink stinks stinky turd","poop shit"],
    ["clown_face","🤡","clown face"],
    ["japanese_ogre","👹","ogre creature devil face fairy fairytale fantasy mask monster scary tale"],
    ["japanese_goblin","👺","goblin angry creature face fairy fairytale fantasy mask mean monster tale"],
    ["ghost","👻","boo creature excited face fairy fairytale fantasy halloween haunting monster scary silly tale"],
    ["alien","👽","creature extraterrestrial face fairy fairytale fantasy monster space tale ufo"],
    ["space_invader","👾","alien monster creature extraterrestrial face fairy fairytale fantasy game gamer games pixelated space tale ufo"],
    ["robot_face","🤖","robot face monster"],
    ["smiley_cat","😺","grinning cat animal face mouth open smile smiling"],
    ["smile_cat","😸","grinning cat with smiling eyes animal eye face grin smile"],
    ["joy_cat","😹","cat with tears of joy animal face laugh laughing lol tear"],
    ["heart_eyes_cat","😻","smiling cat with heart-eyes animal eye face heart love smile"],
    ["smirk_cat","😼","cat with wry smile animal face ironic"],
    ["kissing_cat","😽","kissing cat animal closed eye eyes face kiss"],
    ["scream_cat","🙀","weary cat animal face oh surprised"],
    ["crying_cat_face","😿","crying cat animal cry face sad tear"],
    ["pouting_cat","😾","pouting cat animal face"],
    ["see_no_evil","🙈","see-no-evil monkey embarrassed evil face forbidden forgot gesture hide no omg prohibited scared secret smh watch"],
    ["hear_no_evil","🙉","hear-no-evil monkey animal ears evil face forbidden gesture hear listen no not prohibited secret shh tmi"],
    ["speak_no_evil","🙊","speak-no-evil monkey animal evil face forbidden gesture no not oops prohibited quiet secret speak stealth"],
    ["love_letter","💌","love letter heart mail romance valentine"],
    ["cupid","💘","heart with arrow 143 adorbs date emotion ily love romance valentine"],
    ["gift_heart","💝","heart with ribbon 143 anniversary emotion ily kisses valentine xoxo"],
    ["sparkling_heart","💖","sparkling heart 143 emotion excited good ily kisses morning night sparkle xoxo"],
    ["heartpulse","💗","growing heart 143 emotion excited ily kisses muah nervous pulse xoxo"],
    ["heartbeat","💓","beating heart 143 cardio emotion ily love pulsating pulse"],
    ["revolving_hearts","💞","revolving hearts 143 adorbs anniversary emotion heart"],
    ["two_hearts","💕","two hearts 143 anniversary date dating emotion heart ily kisses love loving xoxo"],
    ["heart_decoration","💟","heart decoration 143 emotion hearth purple white"],
    ["heavy_heart_exclamation_mark_ornament","❣️","heart exclamation heavy mark punctuation"],
    ["broken_heart","💔","broken heart break crushed emotion heartbroken lonely sad"],
    ["heart_on_fire","❤️‍🔥","heart on fire burn love lust sacred"],
    ["mending_heart","❤️‍🩹","mending heart healthier improving recovering recuperating well"],
    ["heart","❤️","red emotion love"],
    ["pink_heart","🩷","pink heart 143 adorable cute emotion ily like love special sweet"],
    ["orange_heart","🧡","orange heart 143"],
    ["yellow_heart","💛","yellow heart 143 cardiac emotion ily love"],
    ["green_heart","💚","green heart 143 emotion ily love romantic"],
    ["blue_heart","💙","blue heart 143 emotion ily love romance"],
    ["light_blue_heart","🩵","light blue heart 143 cute cyan emotion ily like love sky special teal"],
    ["purple_heart","💜","purple heart 143 bestest emotion ily love"],
    ["brown_heart","🤎","brown heart 143"],
    ["black_heart","🖤","black heart evil wicked"],
    ["grey_heart","🩶","grey heart 143 emotion gray ily love silver slate special"],
    ["white_heart","🤍","white heart 143"],
    ["kiss","💋","mark dating emotion heart kissing lips romance sexy"],
    ["100","💯","hundred points a+ agree clearly definitely faithful fleek full keep perfect point score true truth yup"],
    ["anger","💢","symbol angry comic mad upset"],
    ["boom","💥","bomb collide comic explode","collision"],
    ["dizzy","💫","comic shining shooting star stars"],
    ["sweat_drops","💦","sweat droplets comic drip droplet drops splashing squirt water wet work workout"],
    ["dash","💨","dashing away cloud comic fart fast go gone gotta running smoke"],
    ["hole","🕳️",""],
    ["speech_balloon","💬","speech balloon bubble comic dialog message sms talk text typing"],
    ["eye-in-speech-bubble","👁️‍🗨️","eye in speech bubble balloon witness"],
    ["left_speech_bubble","🗨️","left speech bubble balloon dialog"],
    ["right_anger_bubble","🗯️","right anger bubble angry balloon mad"],
    ["thought_balloon","💭","thought balloon bubble cartoon cloud comic daydream decisions dream idea invent invention realize think thoughts wonder"],
    ["zzz","💤","comic good goodnight night sleep sleeping sleepy tired"],
    ["wave","👋","waving hand bye cya g2g greetings gtg hello hey hi later outtie ttfn ttyl yo you"],
    ["raised_back_of_hand","🤚","raised back of hand backhand"],
    ["raised_hand_with_fingers_splayed","🖐️","hand with fingers splayed finger raised stop"],
    ["hand","✋","raised 5 five high stop","raised_hand"],
    ["spock-hand","🖖","vulcan salute finger hand hands"],
    ["rightwards_hand","🫱","rightwards hand handshake hold reach right rightward shake"],
    ["leftwards_hand","🫲","leftwards hand handshake hold left leftward reach shake"],
    ["palm_down_hand","🫳","palm down hand dismiss drop dropped pick shoo up"],
    ["palm_up_hand","🫴","palm up hand beckon catch come hold know lift me offer tell"],
    ["leftwards_pushing_hand","🫷","leftwards pushing hand block five halt high hold leftward pause push refuse slap stop wait"],
    ["rightwards_pushing_hand","🫸","rightwards pushing hand block five halt high hold pause push refuse rightward slap stop wait"],
    ["ok_hand","👌","ok hand awesome bet dope fleek fosho got gotcha legit okay pinch rad sure sweet three"],
    ["pinched_fingers","🤌","pinched fingers gesture hand hold huh interrogation patience relax sarcastic ugh what zip"],
    ["pinching_hand","🤏","pinching hand amount bit fingers little small sort"],
    ["v","✌️","victory hand peace"],
    ["crossed_fingers","🤞","crossed fingers cross finger hand luck","hand_with_index_and_middle_fingers_crossed"],
    ["hand_with_index_finger_and_thumb_crossed","🫰","hand with index finger and thumb crossed <3 expensive heart love money snap"],
    ["i_love_you_hand_sign","🤟","love-you gesture fingers hand ily love three you"],
    ["the_horns","🤘","sign of the horns finger hand rock-on","sign_of_the_horns"],
    ["call_me_hand","🤙","call me hand hang loose shaka"],
    ["point_left","👈","backhand index pointing left finger hand point"],
    ["point_right","👉","backhand index pointing right finger hand point"],
    ["point_up_2","👆","backhand index pointing up finger hand point"],
    ["middle_finger","🖕","middle finger hand","reversed_hand_with_middle_finger_extended"],
    ["point_down","👇","backhand index pointing down finger hand point"],
    ["point_up","☝️","index pointing up finger hand point this"],
    ["index_pointing_at_the_viewer","🫵","index pointing at the viewer finger hand poke you"],
    ["+1","👍","thumbs up good hand like thumb yes","thumbsup"],
    ["-1","👎","thumbs down bad dislike good hand no nope thumb","thumbsdown"],
    ["fist","✊","raised clenched hand punch solidarity"],
    ["facepunch","👊","oncoming fist absolutely agree boom bro bruh bump clenched correct hand knuckle pound rock ttyl","punch"],
    ["left-facing_fist","🤛","left-facing fist leftwards"],
    ["right-facing_fist","🤜","right-facing fist rightwards"],
    ["clap","👏","clapping hands applause approval awesome congrats congratulations excited good great hand homie job nice prayed well yay"],
    ["raised_hands","🙌","raising hands celebration gesture hand hooray praise raised"],
    ["heart_hands","🫶","heart hands <3 love you"],
    ["open_hands","👐","open hands hand hug jazz swerve"],
    ["palms_up_together","🤲","palms up together cupped dua hands pray prayer wish"],
    ["handshake","🤝","agreement deal hand meeting shake"],
    ["pray","🙏","folded hands appreciate ask beg blessed bow cmon five gesture hand high please thanks thx"],
    ["writing_hand","✍️","writing hand write"],
    ["nail_care","💅","nail polish bored care cosmetics done makeup manicure whatever"],
    ["selfie","🤳","camera phone"],
    ["muscle","💪","flexed biceps arm beast bench bodybuilder bro curls flex gains gym jacked press ripped strong weightlift"],
    ["mechanical_arm","🦾","mechanical arm accessibility prosthetic"],
    ["mechanical_leg","🦿","mechanical leg accessibility prosthetic"],
    ["leg","🦵","bent foot kick knee limb"],
    ["foot","🦶","ankle feet kick stomp"],
    ["ear","👂","body ears hear hearing listen listening sound"],
    ["ear_with_hearing_aid","🦻","ear with hearing aid accessibility hard"],
    ["nose","👃","body noses nosey odor smell smells"],
    ["brain","🧠","intelligent smart"],
    ["anatomical_heart","🫀","anatomical heart beat cardiology heartbeat organ pulse real red"],
    ["lungs","🫁","breath breathe exhalation inhalation lung organ respiration"],
    ["tooth","🦷","dentist pearly teeth white"],
    ["bone","🦴","bones dog skeleton wishbone"],
    ["eyes","👀","body eye face googly look looking omg peep see seeing"],
    ["eye","👁️","1 body one"],
    ["tongue","👅","body lick slurp"],
    ["lips","👄","mouth beauty body kiss kissing lipstick"],
    ["biting_lip","🫦","biting lip anxious bite fear flirt flirting kiss lipstick nervous sexy uncomfortable worried worry"],
    ["baby","👶","babies children goo infant newborn pregnant young"],
    ["child","🧒","bright-eyed grandchild kid young younger"],
    ["boy","👦","bright-eyed child grandson kid son young younger"],
    ["girl","👧","bright-eyed child daughter granddaughter kid virgo young younger zodiac"],
    ["adult","🧑","person"],
    ["person_with_blond_hair","👱","person: blond hair blond-haired human person"],
    ["man","👨","adult bro"],
    ["bearded_person","🧔","person: beard bearded person whiskers"],
    ["man_with_beard","🧔‍♂️","man: beard bearded man whiskers"],
    ["woman_with_beard","🧔‍♀️","woman: beard bearded whiskers woman"],
    ["red_haired_man","👨‍🦰","man: red hair adult bro man"],
    ["curly_haired_man","👨‍🦱","man: curly hair adult bro man"],
    ["white_haired_man","👨‍🦳","man: white hair adult bro man"],
    ["bald_man","👨‍🦲","man: bald adult bro man"],
    ["woman","👩","adult lady"],
    ["red_haired_woman","👩‍🦰","woman: red hair adult lady woman"],
    ["red_haired_person","🧑‍🦰","person: red hair adult person"],
    ["curly_haired_woman","👩‍🦱","woman: curly hair adult lady woman"],
    ["curly_haired_person","🧑‍🦱","person: curly hair adult person"],
    ["white_haired_woman","👩‍🦳","woman: white hair adult lady woman"],
    ["white_haired_person","🧑‍🦳","person: white hair adult person"],
    ["bald_woman","👩‍🦲","woman: bald adult lady woman"],
    ["bald_person","🧑‍🦲","person: bald adult person"],
    ["blond-haired-woman","👱‍♀️","woman: blond hair blond-haired blonde woman"],
    ["blond-haired-man","👱‍♂️","man: blond hair blond-haired man"],
    ["older_adult","🧓","older person adult elderly grandparent old wise"],
    ["older_man","👴","old man adult bald elderly gramps grandfather grandpa wise"],
    ["older_woman","👵","old woman adult elderly grandma grandmother granny lady wise"],
    ["person_frowning","🙍","person frowning annoyed disappointed disgruntled disturbed frown frustrated gesture irritated upset"],
    ["man-frowning","🙍‍♂️","man frowning annoyed disappointed disgruntled disturbed frown frustrated gesture irritated upset"],
    ["woman-frowning","🙍‍♀️","woman frowning annoyed disappointed disgruntled disturbed frown frustrated gesture irritated upset"],
    ["person_with_pouting_face","🙎","person pouting disappointed downtrodden frown grimace scowl sulk upset whine"],
    ["man-pouting","🙎‍♂️","man pouting disappointed downtrodden frown grimace scowl sulk upset whine"],
    ["woman-pouting","🙎‍♀️","woman pouting disappointed downtrodden frown grimace scowl sulk upset whine"],
    ["no_good","🙅","person gesturing no forbidden gesture hand not prohibit"],
    ["man-gesturing-no","🙅‍♂️","man gesturing no forbidden gesture hand not prohibit"],
    ["woman-gesturing-no","🙅‍♀️","woman gesturing no forbidden gesture hand not prohibit"],
    ["ok_woman","🙆","person gesturing ok exercise gesture hand omg"],
    ["man-gesturing-ok","🙆‍♂️","man gesturing ok exercise gesture hand omg"],
    ["woman-gesturing-ok","🙆‍♀️","woman gesturing ok exercise gesture hand omg"],
    ["information_desk_person","💁","person tipping hand fetch flick flip gossip sarcasm sarcastic sassy seriously whatever"],
    ["man-tipping-hand","💁‍♂️","man tipping hand fetch flick flip gossip sarcasm sarcastic sassy seriously whatever"],
    ["woman-tipping-hand","💁‍♀️","woman tipping hand fetch flick flip gossip sarcasm sarcastic sassy seriously whatever"],
    ["raising_hand","🙋","person raising hand gesture here know me pick question raise"],
    ["man-raising-hand","🙋‍♂️","man raising hand gesture here know me pick question raise"],
    ["woman-raising-hand","🙋‍♀️","woman raising hand gesture here know me pick question raise"],
    ["deaf_person","🧏","deaf person accessibility ear gesture hear"],
    ["deaf_man","🧏‍♂️","deaf man accessibility ear gesture hear"],
    ["deaf_woman","🧏‍♀️","deaf woman accessibility ear gesture hear"],
    ["bow","🙇","person bowing apology ask beg favor forgive gesture meditate meditation pity regret sorry"],
    ["man-bowing","🙇‍♂️","man bowing apology ask beg bow favor forgive gesture meditate meditation pity regret sorry"],
    ["woman-bowing","🙇‍♀️","woman bowing apology ask beg bow favor forgive gesture meditate meditation pity regret sorry"],
    ["face_palm","🤦","person facepalming again bewilder disbelief exasperation facepalm no not oh omg shock smh"],
    ["man-facepalming","🤦‍♂️","man facepalming again bewilder disbelief exasperation facepalm no not oh omg shock smh"],
    ["woman-facepalming","🤦‍♀️","woman facepalming again bewilder disbelief exasperation facepalm no not oh omg shock smh"],
    ["shrug","🤷","person shrugging doubt dunno guess idk ignorance indifference knows maybe whatever who"],
    ["man-shrugging","🤷‍♂️","man shrugging doubt dunno guess idk ignorance indifference knows maybe shrug whatever who"],
    ["woman-shrugging","🤷‍♀️","woman shrugging doubt dunno guess idk ignorance indifference knows maybe shrug whatever who"],
    ["health_worker","🧑‍⚕️","health worker doctor healthcare nurse therapist"],
    ["male-doctor","👨‍⚕️","man health worker doctor healthcare nurse therapist"],
    ["female-doctor","👩‍⚕️","woman health worker doctor healthcare nurse therapist"],
    ["student","🧑‍🎓","graduate"],
    ["male-student","👨‍🎓","man student graduate"],
    ["female-student","👩‍🎓","woman student graduate"],
    ["teacher","🧑‍🏫","instructor lecturer professor"],
    ["male-teacher","👨‍🏫","man teacher instructor lecturer professor"],
    ["female-teacher","👩‍🏫","woman teacher instructor lecturer professor"],
    ["judge","🧑‍⚖️","justice law scales"],
    ["male-judge","👨‍⚖️","man judge justice law scales"],
    ["female-judge","👩‍⚖️","woman judge justice law scales"],
    ["farmer","🧑‍🌾","gardener rancher"],
    ["male-farmer","👨‍🌾","man farmer gardener rancher"],
    ["female-farmer","👩‍🌾","woman farmer gardener rancher"],
    ["cook","🧑‍🍳","chef"],
    ["male-cook","👨‍🍳","man cook chef"],
    ["female-cook","👩‍🍳","woman cook chef"],
    ["mechanic","🧑‍🔧","electrician plumber tradesperson"],
    ["male-mechanic","👨‍🔧","man mechanic electrician plumber tradesperson"],
    ["female-mechanic","👩‍🔧","woman mechanic electrician plumber tradesperson"],
    ["factory_worker","🧑‍🏭","factory worker assembly industrial"],
    ["male-factory-worker","👨‍🏭","man factory worker assembly industrial"],
    ["female-factory-worker","👩‍🏭","woman factory worker assembly industrial"],
    ["office_worker","🧑‍💼","office worker architect business manager white-collar"],
    ["male-office-worker","👨‍💼","man office worker architect business manager white-collar"],
    ["female-office-worker","👩‍💼","woman office worker architect business manager white-collar"],
    ["scientist","🧑‍🔬","biologist chemist engineer mathematician physicist"],
    ["male-scientist","👨‍🔬","man scientist biologist chemist engineer mathematician physicist"],
    ["female-scientist","👩‍🔬","woman scientist biologist chemist engineer mathematician physicist"],
    ["technologist","🧑‍💻","coder computer developer inventor software"],
    ["male-technologist","👨‍💻","man technologist coder computer developer inventor software"],
    ["female-technologist","👩‍💻","woman technologist coder computer developer inventor software"],
    ["singer","🧑‍🎤","actor entertainer rock rockstar star"],
    ["male-singer","👨‍🎤","man singer actor entertainer rock rockstar star"],
    ["female-singer","👩‍🎤","woman singer actor entertainer rock rockstar star"],
    ["artist","🧑‍🎨","palette"],
    ["male-artist","👨‍🎨","man artist palette"],
    ["female-artist","👩‍🎨","woman artist palette"],
    ["pilot","🧑‍✈️","plane"],
    ["male-pilot","👨‍✈️","man pilot plane"],
    ["female-pilot","👩‍✈️","woman pilot plane"],
    ["astronaut","🧑‍🚀","rocket space"],
    ["male-astronaut","👨‍🚀","man astronaut rocket space"],
    ["female-astronaut","👩‍🚀","woman astronaut rocket space"],
    ["firefighter","🧑‍🚒","fire firetruck"],
    ["male-firefighter","👨‍🚒","man firefighter fire firetruck"],
    ["female-firefighter","👩‍🚒","woman firefighter fire firetruck"],
    ["cop","👮","police officer apprehend arrest citation law over pulled undercover"],
    ["male-police-officer","👮‍♂️","man police officer apprehend arrest citation cop law over pulled undercover"],
    ["female-police-officer","👮‍♀️","woman police officer apprehend arrest citation cop law over pulled undercover"],
    ["sleuth_or_spy","🕵️","detective sleuth spy"],
    ["male-detective","🕵️‍♂️","man detective sleuth spy"],
    ["female-detective","🕵️‍♀️","woman detective sleuth spy"],
    ["guardsman","💂","guard buckingham helmet london palace"],
    ["male-guard","💂‍♂️","man guard buckingham helmet london palace"],
    ["female-guard","💂‍♀️","woman guard buckingham helmet london palace"],
    ["ninja","🥷","assassin fight fighter hidden person secret skills sly soldier stealth war"],
    ["construction_worker","👷","construction worker build fix hardhat hat man person rebuild remodel repair work"],
    ["male-construction-worker","👷‍♂️","man construction worker build fix hardhat hat rebuild remodel repair work"],
    ["female-construction-worker","👷‍♀️","woman construction worker build fix hardhat hat man rebuild remodel repair work"],
    ["person_with_crown","🫅","person with crown monarch noble regal royal royalty"],
    ["prince","🤴","crown fairy fairytale fantasy king royal royalty tale"],
    ["princess","👸","crown fairy fairytale fantasy queen royal royalty tale"],
    ["man_with_turban","👳","person wearing turban"],
    ["man-wearing-turban","👳‍♂️","man wearing turban"],
    ["woman-wearing-turban","👳‍♀️","woman wearing turban"],
    ["man_with_gua_pi_mao","👲","person with skullcap cap chinese gua guapi hat mao pi"],
    ["person_with_headscarf","🧕","woman with headscarf bandana head hijab kerchief mantilla tichel"],
    ["person_in_tuxedo","🤵","person in tuxedo formal wedding"],
    ["man_in_tuxedo","🤵‍♂️","man in tuxedo formal groom wedding"],
    ["woman_in_tuxedo","🤵‍♀️","woman in tuxedo formal wedding"],
    ["bride_with_veil","👰","person with veil wedding"],
    ["man_with_veil","👰‍♂️","man with veil wedding"],
    ["woman_with_veil","👰‍♀️","woman with veil bride wedding"],
    ["pregnant_woman","🤰","pregnant woman"],
    ["pregnant_man","🫃","pregnant man belly bloated full overeat"],
    ["pregnant_person","🫄","pregnant person belly bloated full overeat stuffed"],
    ["breast-feeding","🤱","baby breast feeding mom mother nursing woman"],
    ["woman_feeding_baby","👩‍🍼","woman feeding baby feed mom mother nanny newborn nursing"],
    ["man_feeding_baby","👨‍🍼","man feeding baby dad father feed nanny newborn nursing"],
    ["person_feeding_baby","🧑‍🍼","person feeding baby feed nanny newborn nursing parent"],
    ["angel","👼","baby church face fairy fairytale fantasy tale"],
    ["santa","🎅","claus celebration christmas fairy fantasy father holiday merry tale xmas"],
    ["mrs_claus","🤶","mrs. claus celebration christmas fairy fantasy holiday merry mother mrs santa tale xmas","mother_christmas"],
    ["mx_claus","🧑‍🎄","mx claus celebration christmas fairy fantasy holiday merry santa tale xmas"],
    ["superhero","🦸","good hero superpower"],
    ["male_superhero","🦸‍♂️","man superhero good hero superpower"],
    ["female_superhero","🦸‍♀️","woman superhero good hero heroine superpower"],
    ["supervillain","🦹","bad criminal evil superpower villain"],
    ["male_supervillain","🦹‍♂️","man supervillain bad criminal evil superpower villain"],
    ["female_supervillain","🦹‍♀️","woman supervillain bad criminal evil superpower villain"],
    ["mage","🧙","fantasy magic play sorcerer sorceress sorcery spell summon witch wizard"],
    ["male_mage","🧙‍♂️","man mage fantasy magic play sorcerer sorceress sorcery spell summon witch wizard"],
    ["female_mage","🧙‍♀️","woman mage fantasy magic play sorcerer sorceress sorcery spell summon witch wizard"],
    ["fairy","🧚","fairytale fantasy myth person pixie tale wings"],
    ["male_fairy","🧚‍♂️","man fairy fairytale fantasy myth oberon person pixie puck tale wings"],
    ["female_fairy","🧚‍♀️","woman fairy fairytale fantasy myth person pixie tale titania wings"],
    ["vampire","🧛","blood dracula fangs halloween scary supernatural teeth undead"],
    ["male_vampire","🧛‍♂️","man vampire blood fangs halloween scary supernatural teeth undead"],
    ["female_vampire","🧛‍♀️","woman vampire blood fangs halloween scary supernatural teeth undead"],
    ["merperson","🧜","creature fairytale folklore ocean sea siren trident"],
    ["merman","🧜‍♂️","creature fairytale folklore neptune ocean poseidon sea siren trident triton"],
    ["mermaid","🧜‍♀️","creature fairytale folklore merwoman ocean sea siren trident"],
    ["elf","🧝","elves enchantment fantasy folklore magic magical myth"],
    ["male_elf","🧝‍♂️","man elf elves enchantment fantasy folklore magic magical myth"],
    ["female_elf","🧝‍♀️","woman elf elves enchantment fantasy folklore magic magical myth"],
    ["genie","🧞","djinn fantasy jinn lamp myth rub wishes"],
    ["male_genie","🧞‍♂️","man genie djinn fantasy jinn lamp myth rub wishes"],
    ["female_genie","🧞‍♀️","woman genie djinn fantasy jinn lamp myth rub wishes"],
    ["zombie","🧟","apocalypse dead halloween horror scary undead walking"],
    ["male_zombie","🧟‍♂️","man zombie apocalypse dead halloween horror scary undead walking"],
    ["female_zombie","🧟‍♀️","woman zombie apocalypse dead halloween horror scary undead walking"],
    ["troll","🧌","fairy fantasy monster tale trolling"],
    ["massage","💆","person getting face headache relax relaxing salon soothe spa tension therapy treatment"],
    ["man-getting-massage","💆‍♂️","man getting massage face headache relax relaxing salon soothe spa tension therapy treatment"],
    ["woman-getting-massage","💆‍♀️","woman getting massage face headache relax relaxing salon soothe spa tension therapy treatment"],
    ["haircut","💇","person getting barber beauty chop cosmetology cut groom hair parlor shears style"],
    ["man-getting-haircut","💇‍♂️","man getting haircut barber beauty chop cosmetology cut groom hair parlor person shears style"],
    ["woman-getting-haircut","💇‍♀️","woman getting haircut barber beauty chop cosmetology cut groom hair parlor person shears style"],
    ["walking","🚶","person amble gait hike man pace pedestrian stride stroll walk"],
    ["man-walking","🚶‍♂️","man walking amble gait hike pace pedestrian stride stroll walk"],
    ["woman-walking","🚶‍♀️","woman walking amble gait hike man pace pedestrian stride stroll walk"],
    ["person_walking_facing_right","🚶‍➡️","person walking: facing right amble gait hike man pace pedestrian stride stroll walk walking"],
    ["woman_walking_facing_right","🚶‍♀️‍➡️","woman walking: facing right amble gait hike man pace pedestrian stride stroll walk walking"],
    ["man_walking_facing_right","🚶‍♂️‍➡️","man walking: facing right amble gait hike pace pedestrian stride stroll walk walking"],
    ["standing_person","🧍","person standing stand"],
    ["man_standing","🧍‍♂️","man standing stand"],
    ["woman_standing","🧍‍♀️","woman standing stand"],
    ["kneeling_person","🧎","person kneeling kneel knees"],
    ["man_kneeling","🧎‍♂️","man kneeling kneel knees"],
    ["woman_kneeling","🧎‍♀️","woman kneeling kneel knees"],
    ["person_kneeling_facing_right","🧎‍➡️","person kneeling: facing right kneel kneeling knees"],
    ["woman_kneeling_facing_right","🧎‍♀️‍➡️","woman kneeling: facing right kneel kneeling knees"],
    ["man_kneeling_facing_right","🧎‍♂️‍➡️","man kneeling: facing right kneel kneeling knees"],
    ["person_with_probing_cane","🧑‍🦯","person with white cane accessibility blind probing"],
    ["person_with_white_cane_facing_right","🧑‍🦯‍➡️","person with white cane: facing right accessibility blind cane probing"],
    ["man_with_probing_cane","👨‍🦯","man with white cane accessibility blind probing"],
    ["man_with_white_cane_facing_right","👨‍🦯‍➡️","man with white cane: facing right accessibility blind cane probing"],
    ["woman_with_probing_cane","👩‍🦯","woman with white cane accessibility blind probing"],
    ["woman_with_white_cane_facing_right","👩‍🦯‍➡️","woman with white cane: facing right accessibility blind cane probing"],
    ["person_in_motorized_wheelchair","🧑‍🦼","person in motorized wheelchair accessibility"],
    ["person_in_motorized_wheelchair_facing_right","🧑‍🦼‍➡️","person in motorized wheelchair: facing right accessibility wheelchair"],
    ["man_in_motorized_wheelchair","👨‍🦼","man in motorized wheelchair accessibility"],
    ["man_in_motorized_wheelchair_facing_right","👨‍🦼‍➡️","man in motorized wheelchair: facing right accessibility wheelchair"],
    ["woman_in_motorized_wheelchair","👩‍🦼","woman in motorized wheelchair accessibility"],
    ["woman_in_motorized_wheelchair_facing_right","👩‍🦼‍➡️","woman in motorized wheelchair: facing right accessibility wheelchair"],
    ["person_in_manual_wheelchair","🧑‍🦽","person in manual wheelchair accessibility"],
    ["person_in_manual_wheelchair_facing_right","🧑‍🦽‍➡️","person in manual wheelchair: facing right accessibility wheelchair"],
    ["man_in_manual_wheelchair","👨‍🦽","man in manual wheelchair accessibility"],
    ["man_in_manual_wheelchair_facing_right","👨‍🦽‍➡️","man in manual wheelchair: facing right accessibility wheelchair"],
    ["woman_in_manual_wheelchair","👩‍🦽","woman in manual wheelchair accessibility"],
    ["woman_in_manual_wheelchair_facing_right","👩‍🦽‍➡️","woman in manual wheelchair: facing right accessibility wheelchair"],
    ["runner","🏃","person fast hurry marathon move quick race racing run rush speed","running"],
    ["man-running","🏃‍♂️","man running fast hurry marathon move quick race racing run rush speed"],
    ["woman-running","🏃‍♀️","woman running fast hurry marathon move quick race racing run rush speed"],
    ["person_running_facing_right","🏃‍➡️","person running: facing right fast hurry marathon move quick race racing run rush speed"],
    ["woman_running_facing_right","🏃‍♀️‍➡️","woman running: facing right fast hurry marathon move quick race racing run rush speed"],
    ["man_running_facing_right","🏃‍♂️‍➡️","man running: facing right fast hurry marathon move quick race racing run rush speed"],
    ["dancer","💃","woman dancing dance elegant festive flair flamenco groove let’s salsa tango"],
    ["man_dancing","🕺","man dancing dance dancer elegant festive flair flamenco groove let’s salsa tango"],
    ["man_in_business_suit_levitating","🕴️","person in suit levitating business"],
    ["dancers","👯","people with bunny ears bestie bff counterpart dancer double ear identical pair party partying soulmate twin twinsies"],
    ["men-with-bunny-ears-partying","👯‍♂️","men with bunny ears bestie bff counterpart dancer double ear identical pair party partying people soulmate twin twinsies","man-with-bunny-ears-partying"],
    ["women-with-bunny-ears-partying","👯‍♀️","women with bunny ears bestie bff counterpart dancer double ear identical pair party partying people soulmate twin twinsies","woman-with-bunny-ears-partying"],
    ["person_in_steamy_room","🧖","person in steamy room day luxurious pamper relax sauna spa steam steambath unwind"],
    ["man_in_steamy_room","🧖‍♂️","man in steamy room day luxurious pamper relax sauna spa steam steambath unwind"],
    ["woman_in_steamy_room","🧖‍♀️","woman in steamy room day luxurious pamper relax sauna spa steam steambath unwind"],
    ["person_climbing","🧗","person climbing climb climber mountain rock scale up"],
    ["man_climbing","🧗‍♂️","man climbing climb climber mountain rock scale up"],
    ["woman_climbing","🧗‍♀️","woman climbing climb climber mountain rock scale up"],
    ["fencer","🤺","person fencing sword"],
    ["horse_racing","🏇","horse racing jockey racehorse riding sport"],
    ["skier","⛷️","ski snow"],
    ["snowboarder","🏂","ski snow snowboard sport"],
    ["golfer","🏌️","person golfing ball birdie caddy driving golf green pga putt range tee"],
    ["man-golfing","🏌️‍♂️","man golfing ball birdie caddy driving golf green pga putt range tee"],
    ["woman-golfing","🏌️‍♀️","woman golfing ball birdie caddy driving golf green pga putt range tee"],
    ["surfer","🏄","person surfing beach ocean sport surf swell waves"],
    ["man-surfing","🏄‍♂️","man surfing beach ocean sport surf surfer swell waves"],
    ["woman-surfing","🏄‍♀️","woman surfing beach ocean person sport surf surfer swell waves"],
    ["rowboat","🚣","person rowing boat canoe cruise fishing lake oar paddle raft river row"],
    ["man-rowing-boat","🚣‍♂️","man rowing boat canoe cruise fishing lake oar paddle raft river row rowboat"],
    ["woman-rowing-boat","🚣‍♀️","woman rowing boat canoe cruise fishing lake oar paddle raft river row rowboat"],
    ["swimmer","🏊","person swimming freestyle sport swim triathlon"],
    ["man-swimming","🏊‍♂️","man swimming freestyle sport swim swimmer triathlon"],
    ["woman-swimming","🏊‍♀️","woman swimming freestyle man sport swim swimmer triathlon"],
    ["person_with_ball","⛹️","person bouncing ball athletic basketball championship dribble net player throw"],
    ["man-bouncing-ball","⛹️‍♂️","man bouncing ball athletic basketball championship dribble net player throw"],
    ["woman-bouncing-ball","⛹️‍♀️","woman bouncing ball athletic basketball championship dribble net player throw"],
    ["weight_lifter","🏋️","person lifting weights barbell bodybuilder deadlift lifter powerlifting weight weightlifter workout"],
    ["man-lifting-weights","🏋️‍♂️","man lifting weights barbell bodybuilder deadlift lifter powerlifting weight weightlifter workout"],
    ["woman-lifting-weights","🏋️‍♀️","woman lifting weights barbell bodybuilder deadlift lifter powerlifting weight weightlifter workout"],
    ["bicyclist","🚴","person biking bicycle bike cycle cyclist riding sport"],
    ["man-biking","🚴‍♂️","man biking bicycle bicyclist bike cycle cyclist riding sport"],
    ["woman-biking","🚴‍♀️","woman biking bicycle bicyclist bike cycle cyclist riding sport"],
    ["mountain_bicyclist","🚵","person mountain biking bicycle bicyclist bike cycle cyclist riding sport"],
    ["man-mountain-biking","🚵‍♂️","man mountain biking bicycle bicyclist bike cycle cyclist riding sport"],
    ["woman-mountain-biking","🚵‍♀️","woman mountain biking bicycle bicyclist bike cycle cyclist riding sport"],
    ["person_doing_cartwheel","🤸","person cartwheeling active cartwheel excited flip gymnastics happy somersault"],
    ["man-cartwheeling","🤸‍♂️","man cartwheeling active cartwheel excited flip gymnastics happy somersault"],
    ["woman-cartwheeling","🤸‍♀️","woman cartwheeling active cartwheel excited flip gymnastics happy somersault"],
    ["wrestlers","🤼","people wrestling combat duel grapple ring tournament wrestle"],
    ["man-wrestling","🤼‍♂️","men wrestling combat duel grapple ring tournament wrestle"],
    ["woman-wrestling","🤼‍♀️","women wrestling combat duel grapple ring tournament wrestle"],
    ["water_polo","🤽","person playing water polo sport swimming waterpolo"],
    ["man-playing-water-polo","🤽‍♂️","man playing water polo sport swimming waterpolo"],
    ["woman-playing-water-polo","🤽‍♀️","woman playing water polo sport swimming waterpolo"],
    ["handball","🤾","person playing athletics ball catch chuck hurl lob pitch sport throw toss"],
    ["man-playing-handball","🤾‍♂️","man playing handball athletics ball catch chuck hurl lob pitch sport throw toss"],
    ["woman-playing-handball","🤾‍♀️","woman playing handball athletics ball catch chuck hurl lob pitch sport throw toss"],
    ["juggling","🤹","person act balance balancing handle juggle manage multitask skill"],
    ["man-juggling","🤹‍♂️","man juggling act balance balancing handle juggle manage multitask skill"],
    ["woman-juggling","🤹‍♀️","woman juggling act balance balancing handle juggle manage multitask skill"],
    ["person_in_lotus_position","🧘","person in lotus position cross legged legs meditation peace relax serenity yoga yogi zen"],
    ["man_in_lotus_position","🧘‍♂️","man in lotus position cross legged legs meditation peace relax serenity yoga yogi zen"],
    ["woman_in_lotus_position","🧘‍♀️","woman in lotus position cross legged legs meditation peace relax serenity yoga yogi zen"],
    ["bath","🛀","person taking bathtub tub"],
    ["sleeping_accommodation","🛌","person in bed bedtime good goodnight hotel nap night sleep tired zzz"],
    ["people_holding_hands","🧑‍🤝‍🧑","people holding hands bae bestie bff couple dating flirt friends hand hold twins"],
    ["two_women_holding_hands","👭","women holding hands bae bestie bff couple dating flirt friends girls hand hold sisters twins","women_holding_hands"],
    ["man_and_woman_holding_hands","👫","woman and man holding hands bae bestie bff dating flirt friends hand hold twins","woman_and_man_holding_hands couple"],
    ["two_men_holding_hands","👬","men holding hands bae bestie bff boys brothers couple dating flirt friends hand hold twins","men_holding_hands"],
    ["couplekiss","💏","kiss anniversary babe bae couple date dating heart love mwah person romance together xoxo"],
    ["woman-kiss-man","👩‍❤️‍💋‍👨","kiss: woman, man anniversary babe bae couple date dating heart kiss love mwah person romance together woman xoxo"],
    ["man-kiss-man","👨‍❤️‍💋‍👨","kiss: man, man anniversary babe bae couple date dating heart kiss love mwah person romance together xoxo"],
    ["woman-kiss-woman","👩‍❤️‍💋‍👩","kiss: woman, woman anniversary babe bae couple date dating heart kiss love mwah person romance together xoxo"],
    ["couple_with_heart","💑","couple with heart anniversary babe bae dating kiss love person relationship romance together you"],
    ["woman-heart-man","👩‍❤️‍👨","couple with heart: woman, man anniversary babe bae dating heart kiss love person relationship romance together woman you"],
    ["man-heart-man","👨‍❤️‍👨","couple with heart: man, man anniversary babe bae dating heart kiss love person relationship romance together you"],
    ["woman-heart-woman","👩‍❤️‍👩","couple with heart: woman, woman anniversary babe bae dating heart kiss love person relationship romance together you"],
    ["man-woman-boy","👨‍👩‍👦","family: man, woman, boy child family man woman"],
    ["man-woman-girl","👨‍👩‍👧","family: man, woman, girl child family man woman"],
    ["man-woman-girl-boy","👨‍👩‍👧‍👦","family: man, woman, girl, boy child family girl man woman"],
    ["man-woman-boy-boy","👨‍👩‍👦‍👦","family: man, woman, boy, boy child family man woman"],
    ["man-woman-girl-girl","👨‍👩‍👧‍👧","family: man, woman, girl, girl child family man woman"],
    ["man-man-boy","👨‍👨‍👦","family: man, boy child family man"],
    ["man-man-girl","👨‍👨‍👧","family: man, girl child family man"],
    ["man-man-girl-boy","👨‍👨‍👧‍👦","family: man, girl, boy child family girl man"],
    ["man-man-boy-boy","👨‍👨‍👦‍👦","family: man, boy, boy child family man"],
    ["man-man-girl-girl","👨‍👨‍👧‍👧","family: man, girl, girl child family man"],
    ["woman-woman-boy","👩‍👩‍👦","family: woman, boy child family woman"],
    ["woman-woman-girl","👩‍👩‍👧","family: woman, girl child family woman"],
    ["woman-woman-girl-boy","👩‍👩‍👧‍👦","family: woman, girl, boy child family girl woman"],
    ["woman-woman-boy-boy","👩‍👩‍👦‍👦","family: woman, boy, boy child family woman"],
    ["woman-woman-girl-girl","👩‍👩‍👧‍👧","family: woman, girl, girl child family woman"],
    ["man-boy","👨‍👦","family: man, boy child family man"],
    ["man-boy-boy","👨‍👦‍👦","family: man, boy, boy child family man"],
    ["man-girl","👨‍👧","family: man, girl child family man"],
    ["man-girl-boy","👨‍👧‍👦","family: man, girl, boy child family girl man"],
    ["man-girl-girl","👨‍👧‍👧","family: man, girl, girl child family man"],
    ["woman-boy","👩‍👦","family: woman, boy child family woman"],
    ["woman-boy-boy","👩‍👦‍👦","family: woman, boy, boy child family woman"],
    ["woman-girl","👩‍👧","family: woman, girl child family woman"],
    ["woman-girl-boy","👩‍👧‍👦","family: woman, girl, boy child family girl woman"],
    ["woman-girl-girl","👩‍👧‍👧","family: woman, girl, girl child family woman"],
    ["speaking_head_in_silhouette","🗣️","speaking head face silhouette speak"],
    ["bust_in_silhouette","👤","bust in silhouette mysterious shadow"],
    ["busts_in_silhouette","👥","busts in silhouette bff bust everyone friend friends people"],
    ["people_hugging","🫂","people hugging comfort embrace farewell friendship goodbye hello hug love thanks"],
    ["family","👪","child"],
    ["family_adult_adult_child","🧑‍🧑‍🧒","family: adult, child adult family"],
    ["family_adult_adult_child_child","🧑‍🧑‍🧒‍🧒","family: adult, child, child adult family"],
    ["family_adult_child","🧑‍🧒","family: adult, child adult family"],
    ["family_adult_child_child","🧑‍🧒‍🧒","family: adult, child, child adult family"],
    ["footprints","👣","barefoot clothing footprint omw print walk"],
    ["fingerprint","🫆","clue crime detective forensics identity mystery print safety trace"],
  ]],
  ["nature", [
    ["monkey_face","🐵","monkey face animal banana"],
    ["monkey","🐒","animal banana"],
    ["gorilla","🦍","animal"],
    ["orangutan","🦧","animal ape monkey"],
    ["dog","🐶","face adorbs animal pet puppies puppy"],
    ["dog2","🐕","dog animal animals dogs pet"],
    ["guide_dog","🦮","guide dog accessibility animal blind"],
    ["service_dog","🐕‍🦺","service dog accessibility animal assistance"],
    ["poodle","🐩","animal dog fluffy"],
    ["wolf","🐺","animal face"],
    ["fox_face","🦊","fox animal face"],
    ["raccoon","🦝","animal curious sly"],
    ["cat","🐱","face animal kitten kitty pet"],
    ["cat2","🐈","cat animal animals cats kitten pet"],
    ["black_cat","🐈‍⬛","black cat animal feline halloween meow unlucky"],
    ["lion_face","🦁","lion alpha animal face leo mane order rawr roar safari strong zodiac"],
    ["tiger","🐯","face animal big cat predator"],
    ["tiger2","🐅","tiger animal big cat predator zoo"],
    ["leopard","🐆","animal big cat predator zoo"],
    ["horse","🐴","face animal dressage equine farm horses"],
    ["moose","🫎","alces animal antlers elk mammal"],
    ["donkey","🫏","animal ass burro hinny mammal mule stubborn"],
    ["racehorse","🐎","horse animal equestrian farm racing"],
    ["unicorn_face","🦄","unicorn face"],
    ["zebra_face","🦓","zebra animal stripe"],
    ["deer","🦌","animal"],
    ["bison","🦬","animal buffalo herd wisent"],
    ["cow","🐮","face animal farm milk moo"],
    ["ox","🐂","animal animals bull farm taurus zodiac"],
    ["water_buffalo","🐃","water buffalo animal zoo"],
    ["cow2","🐄","cow animal animals farm milk moo"],
    ["pig","🐷","face animal bacon farm pork"],
    ["pig2","🐖","pig animal bacon farm pork sow"],
    ["boar","🐗","animal pig"],
    ["pig_nose","🐽","pig nose animal face farm smell snout"],
    ["ram","🐏","animal aries horns male sheep zodiac zoo"],
    ["sheep","🐑","ewe animal baa farm female fluffy lamb wool"],
    ["goat","🐐","animal capricorn farm milk zodiac"],
    ["dromedary_camel","🐪","camel animal desert dromedary hump one"],
    ["camel","🐫","two-hump animal bactrian desert hump two"],
    ["llama","🦙","alpaca animal guanaco vicuña wool"],
    ["giraffe_face","🦒","giraffe animal spots"],
    ["elephant","🐘","animal"],
    ["mammoth","🦣","animal extinction large tusk wooly"],
    ["rhinoceros","🦏","animal"],
    ["hippopotamus","🦛","animal hippo"],
    ["mouse","🐭","face animal"],
    ["mouse2","🐁","mouse animal animals"],
    ["rat","🐀","animal"],
    ["hamster","🐹","animal face pet"],
    ["rabbit","🐰","face animal bunny pet"],
    ["rabbit2","🐇","rabbit animal bunny pet"],
    ["chipmunk","🐿️","animal squirrel"],
    ["beaver","🦫","animal dam teeth"],
    ["hedgehog","🦔","animal spiny"],
    ["bat","🦇","animal vampire"],
    ["bear","🐻","animal face grizzly growl honey"],
    ["polar_bear","🐻‍❄️","polar bear animal arctic white"],
    ["koala","🐨","animal australia bear down face marsupial under"],
    ["panda_face","🐼","panda animal bamboo face"],
    ["sloth","🦥","lazy slow"],
    ["otter","🦦","animal fishing playful"],
    ["skunk","🦨","animal stink"],
    ["kangaroo","🦘","animal joey jump marsupial"],
    ["badger","🦡","animal honey pester"],
    ["feet","🐾","paw prints paws print","paw_prints"],
    ["turkey","🦃","bird gobble thanksgiving"],
    ["chicken","🐔","animal bird ornithology"],
    ["rooster","🐓","animal bird ornithology"],
    ["hatching_chick","🐣","hatching chick animal baby bird egg"],
    ["baby_chick","🐤","baby chick animal bird ornithology"],
    ["hatched_chick","🐥","front-facing baby chick animal bird newborn ornithology"],
    ["bird","🐦","animal ornithology"],
    ["penguin","🐧","animal antarctica bird ornithology"],
    ["dove_of_peace","🕊️","dove bird fly ornithology peace"],
    ["eagle","🦅","animal bird ornithology"],
    ["duck","🦆","animal bird ornithology"],
    ["swan","🦢","animal bird cygnet duckling ornithology ugly"],
    ["owl","🦉","animal bird ornithology wise"],
    ["dodo","🦤","animal bird extinction large ornithology"],
    ["feather","🪶","bird flight light plumage"],
    ["flamingo","🦩","animal bird flamboyant ornithology tropical"],
    ["peacock","🦚","animal bird colorful ornithology ostentatious peahen pretty proud"],
    ["parrot","🦜","animal bird ornithology pirate talk"],
    ["wing","🪽","angelic ascend aviation bird fly flying heavenly mythology soar"],
    ["black_bird","🐦‍⬛","black bird animal beak caw corvid crow ornithology raven rook"],
    ["goose","🪿","animal bird duck flock fowl gaggle gander geese honk ornithology silly"],
    ["phoenix","🐦‍🔥","ascend ascension emerge fantasy firebird glory immortal rebirth reincarnation reinvent renewal revival revive rise transform"],
    ["frog","🐸","animal face"],
    ["crocodile","🐊","animal zoo"],
    ["turtle","🐢","animal terrapin tortoise"],
    ["lizard","🦎","animal reptile"],
    ["snake","🐍","animal bearer ophiuchus serpent zodiac"],
    ["dragon_face","🐲","dragon face animal fairy fairytale tale"],
    ["dragon","🐉","animal fairy fairytale knights tale"],
    ["sauropod","🦕","brachiosaurus brontosaurus dinosaur diplodocus"],
    ["t-rex","🦖","dinosaur rex t tyrannosaurus"],
    ["whale","🐳","spouting animal beach face ocean"],
    ["whale2","🐋","whale animal beach ocean"],
    ["dolphin","🐬","animal beach ocean","flipper"],
    ["seal","🦭","animal lion ocean sea"],
    ["fish","🐟","animal dinner fishes fishing pisces zodiac"],
    ["tropical_fish","🐠","tropical fish animal fishes"],
    ["blowfish","🐡","animal fish"],
    ["shark","🦈","animal fish"],
    ["octopus","🐙","animal creature ocean"],
    ["shell","🐚","spiral animal beach conch sea"],
    ["coral","🪸","change climate ocean reef sea"],
    ["jellyfish","🪼","animal aquarium burn invertebrate jelly life marine ocean ouch plankton sea sting stinger tentacles"],
    ["crab","🦀","cancer zodiac"],
    ["lobster","🦞","animal bisque claws seafood"],
    ["shrimp","🦐","food shellfish small"],
    ["squid","🦑","animal food mollusk"],
    ["oyster","🦪","diving pearl"],
    ["snail","🐌","animal escargot garden nature slug"],
    ["butterfly","🦋","insect pretty"],
    ["bug","🐛","animal garden insect"],
    ["ant","🐜","animal garden insect"],
    ["bee","🐝","animal bumblebee honey insect nature spring","honeybee"],
    ["beetle","🪲","animal bug insect"],
    ["ladybug","🐞","lady beetle animal garden insect ladybird nature","lady_beetle"],
    ["cricket","🦗","animal bug grasshopper insect orthoptera"],
    ["cockroach","🪳","animal insect pest roach"],
    ["spider","🕷️","animal insect"],
    ["spider_web","🕸️","spider web"],
    ["scorpion","🦂","scorpio scorpius zodiac"],
    ["mosquito","🦟","bite disease fever insect malaria pest virus"],
    ["fly","🪰","animal disease insect maggot pest rotting"],
    ["worm","🪱","animal annelid earthworm parasite"],
    ["microbe","🦠","amoeba bacteria science virus"],
    ["bouquet","💐","anniversary birthday date flower love plant romance"],
    ["cherry_blossom","🌸","cherry blossom flower plant spring springtime"],
    ["white_flower","💮","white flower"],
    ["lotus","🪷","beauty buddhism calm flower hinduism peace purity serenity"],
    ["rosette","🏵️","plant"],
    ["rose","🌹","beauty elegant flower love plant red valentine"],
    ["wilted_flower","🥀","wilted flower dying"],
    ["hibiscus","🌺","flower plant"],
    ["sunflower","🌻","flower outdoors plant sun"],
    ["blossom","🌼","buttercup dandelion flower plant"],
    ["tulip","🌷","blossom flower growth plant"],
    ["hyacinth","🪻","bloom bluebonnet flower indigo lavender lilac lupine plant purple shrub snapdragon spring violet"],
    ["seedling","🌱","plant sapling sprout young"],
    ["potted_plant","🪴","potted plant decor grow house nurturing pot"],
    ["evergreen_tree","🌲","evergreen tree christmas forest pine"],
    ["deciduous_tree","🌳","deciduous tree forest green habitat shedding"],
    ["palm_tree","🌴","palm tree beach plant tropical"],
    ["cactus","🌵","desert drought nature plant"],
    ["ear_of_rice","🌾","sheaf of rice ear grain grains plant"],
    ["herb","🌿","leaf plant"],
    ["shamrock","☘️","irish plant"],
    ["four_leaf_clover","🍀","four leaf clover 4 four-leaf irish lucky plant"],
    ["maple_leaf","🍁","maple leaf falling"],
    ["fallen_leaf","🍂","fallen leaf autumn fall falling"],
    ["leaves","🍃","leaf fluttering in wind blow flutter"],
    ["empty_nest","🪹","empty nest branch home nesting"],
    ["nest_with_eggs","🪺","nest with eggs bird branch egg nesting"],
    ["mushroom","🍄","fungus toadstool"],
    ["leafless_tree","🪾","leafless tree bare barren branches dead drought trunk winter wood"],
  ]],
  ["food", [
    ["grapes","🍇","dionysus fruit grape"],
    ["melon","🍈","cantaloupe fruit"],
    ["watermelon","🍉","fruit"],
    ["tangerine","🍊","c citrus fruit nectarine orange vitamin"],
    ["lemon","🍋","citrus fruit sour"],
    ["lime","🍋‍🟩","acidity citrus cocktail fruit garnish key margarita mojito refreshing salsa sour tangy tequila tropical zest"],
    ["banana","🍌","fruit potassium"],
    ["pineapple","🍍","colada fruit pina tropical"],
    ["mango","🥭","food fruit tropical"],
    ["apple","🍎","red diet food fruit health ripe"],
    ["green_apple","🍏","green apple fruit"],
    ["pear","🍐","fruit"],
    ["peach","🍑","fruit"],
    ["cherries","🍒","berries cherry fruit red"],
    ["strawberry","🍓","berry fruit"],
    ["blueberries","🫐","berries berry bilberry blue blueberry food fruit"],
    ["kiwifruit","🥝","kiwi fruit food"],
    ["tomato","🍅","food fruit vegetable"],
    ["olive","🫒","food"],
    ["coconut","🥥","colada palm piña"],
    ["avocado","🥑","food fruit"],
    ["eggplant","🍆","aubergine vegetable"],
    ["potato","🥔","food vegetable"],
    ["carrot","🥕","food vegetable"],
    ["corn","🌽","ear of crops farm maize maze"],
    ["hot_pepper","🌶️","hot pepper"],
    ["bell_pepper","🫑","bell pepper capsicum food vegetable"],
    ["cucumber","🥒","food pickle vegetable"],
    ["leafy_green","🥬","leafy green bok burgers cabbage choy kale lettuce salad"],
    ["broccoli","🥦","cabbage wild"],
    ["garlic","🧄","flavoring"],
    ["onion","🧅","flavoring"],
    ["peanuts","🥜","food nut peanut vegetable"],
    ["beans","🫘","food kidney legume small"],
    ["chestnut","🌰","almond plant"],
    ["ginger_root","🫚","ginger root beer health herb natural spice"],
    ["pea_pod","🫛","pea pod beans beanstalk edamame legume soybean vegetable veggie"],
    ["brown_mushroom","🍄‍🟫","brown mushroom food fungi fungus nature pizza portobello shiitake shroom spore sprout toppings truffle vegetable vegetarian veggie"],
    ["root_vegetable","🫜","root vegetable beet food garden radish salad turnip vegetarian"],
    ["bread","🍞","carbs food grain loaf restaurant toast wheat"],
    ["croissant","🥐","bread breakfast crescent food french roll"],
    ["baguette_bread","🥖","baguette bread food french"],
    ["flatbread","🫓","arepa bread food gordita lavash naan pita"],
    ["pretzel","🥨","convoluted twisted"],
    ["bagel","🥯","bakery bread breakfast schmear"],
    ["pancakes","🥞","breakfast crêpe food hotcake pancake"],
    ["waffle","🧇","breakfast indecisive iron"],
    ["cheese_wedge","🧀","cheese wedge"],
    ["meat_on_bone","🍖","meat on bone"],
    ["poultry_leg","🍗","poultry leg bone chicken drumstick hungry turkey"],
    ["cut_of_meat","🥩","cut of meat chop lambchop porkchop red steak"],
    ["bacon","🥓","breakfast food meat"],
    ["hamburger","🍔","burger eat fast food hungry"],
    ["fries","🍟","french fast food"],
    ["pizza","🍕","cheese food hungry pepperoni slice"],
    ["hotdog","🌭","hot dog frankfurter sausage"],
    ["sandwich","🥪","bread"],
    ["taco","🌮","mexican"],
    ["burrito","🌯","mexican wrap"],
    ["tamale","🫔","food mexican pamonha wrapped"],
    ["stuffed_flatbread","🥙","stuffed flatbread falafel food gyro kebab"],
    ["falafel","🧆","chickpea meatball"],
    ["egg","🥚","breakfast food"],
    ["fried_egg","🍳","breakfast easy egg fry frying over pan restaurant side sunny up","cooking"],
    ["shallow_pan_of_food","🥘","shallow pan of food casserole paella"],
    ["stew","🍲","pot of food soup"],
    ["fondue","🫕","cheese chocolate food melted pot ski"],
    ["bowl_with_spoon","🥣","bowl with spoon breakfast cereal congee oatmeal porridge"],
    ["green_salad","🥗","green salad food"],
    ["popcorn","🍿","corn movie pop"],
    ["butter","🧈","dairy"],
    ["salt","🧂","condiment flavor mad salty shaker taste upset"],
    ["canned_food","🥫","canned food can"],
    ["bento","🍱","box food"],
    ["rice_cracker","🍘","rice cracker food"],
    ["rice_ball","🍙","rice ball food japanese"],
    ["rice","🍚","cooked food"],
    ["curry","🍛","rice food"],
    ["ramen","🍜","steaming bowl chopsticks food noodle pho soup"],
    ["spaghetti","🍝","food meatballs pasta restaurant"],
    ["sweet_potato","🍠","roasted sweet potato food"],
    ["oden","🍢","food kebab restaurant seafood skewer stick"],
    ["sushi","🍣","food"],
    ["fried_shrimp","🍤","fried shrimp prawn tempura"],
    ["fish_cake","🍥","fish cake with swirl food pastry restaurant"],
    ["moon_cake","🥮","moon cake autumn festival yuèbǐng"],
    ["dango","🍡","dessert japanese skewer stick sweet"],
    ["dumpling","🥟","empanada gyōza jiaozi pierogi potsticker"],
    ["fortune_cookie","🥠","fortune cookie prophecy"],
    ["takeout_box","🥡","takeout box chopsticks delivery food oyster pail"],
    ["icecream","🍦","soft ice cream dessert food restaurant serve sweet"],
    ["shaved_ice","🍧","shaved ice dessert restaurant sweet"],
    ["ice_cream","🍨","ice cream dessert food restaurant sweet"],
    ["doughnut","🍩","breakfast dessert donut food sweet"],
    ["cookie","🍪","chip chocolate dessert sweet"],
    ["birthday","🎂","cake bday celebration dessert happy pastry sweet"],
    ["cake","🍰","shortcake dessert pastry slice sweet"],
    ["cupcake","🧁","bakery dessert sprinkles sugar sweet treat"],
    ["pie","🥧","apple filling fruit meat pastry pumpkin slice"],
    ["chocolate_bar","🍫","chocolate bar candy dessert halloween sweet tooth"],
    ["candy","🍬","cavities dessert halloween restaurant sweet tooth wrapper"],
    ["lollipop","🍭","candy dessert food restaurant sweet"],
    ["custard","🍮","dessert pudding sweet"],
    ["honey_pot","🍯","honey pot barrel bear food honeypot jar sweet"],
    ["baby_bottle","🍼","baby bottle babies birth born drink infant milk newborn"],
    ["glass_of_milk","🥛","glass of milk drink"],
    ["coffee","☕","hot beverage cafe caffeine chai drink morning steaming tea"],
    ["teapot","🫖","brew drink food pot tea"],
    ["tea","🍵","teacup without handle beverage cup drink oolong"],
    ["sake","🍶","bar beverage bottle cup drink restaurant"],
    ["champagne","🍾","bottle with popping cork bar drink"],
    ["wine_glass","🍷","wine glass alcohol bar beverage booze club drink drinking drinks restaurant"],
    ["cocktail","🍸","glass alcohol bar booze club drink drinking drinks mad martini men"],
    ["tropical_drink","🍹","tropical drink alcohol bar booze club cocktail drinking drinks drunk mai party tai tropics"],
    ["beer","🍺","mug alcohol ale bar booze drink drinking drinks octoberfest oktoberfest pint stein summer"],
    ["beers","🍻","clinking beer mugs alcohol bar booze bottoms cheers clink drinking drinks"],
    ["clinking_glasses","🥂","clinking glasses celebrate clink drink glass"],
    ["tumbler_glass","🥃","tumbler glass liquor scotch shot whiskey whisky"],
    ["pouring_liquid","🫗","pouring liquid accident drink empty glass oops pour spill water"],
    ["cup_with_straw","🥤","cup with straw drink juice malt soda soft water"],
    ["bubble_tea","🧋","bubble tea boba food milk pearl"],
    ["beverage_box","🧃","beverage box juice straw sweet"],
    ["mate_drink","🧉","mate drink"],
    ["ice_cube","🧊","ice cold cube iceberg"],
    ["chopsticks","🥢","hashi jeotgarak kuaizi"],
    ["knife_fork_plate","🍽️","fork and knife with plate cooking dinner eat"],
    ["fork_and_knife","🍴","fork and knife breakfast breaky cooking cutlery delicious dinner eat feed food hungry lunch restaurant yum yummy"],
    ["spoon","🥄","eat tableware"],
    ["hocho","🔪","kitchen chef cooking tool weapon","knife"],
    ["jar","🫙","condiment container empty nothing sauce store"],
    ["amphora","🏺","aquarius cooking drink jug tool weapon zodiac"],
  ]],
  ["travel", [
    ["earth_africa","🌍","globe showing europe-africa africa earth europe world"],
    ["earth_americas","🌎","globe showing americas earth world"],
    ["earth_asia","🌏","globe showing asia-australia asia australia earth world"],
    ["globe_with_meridians","🌐","globe with meridians earth internet web world worldwide"],
    ["world_map","🗺️","world map"],
    ["japan","🗾","map of"],
    ["compass","🧭","direction magnetic navigation orienteering"],
    ["snow_capped_mountain","🏔️","snow-capped mountain cold snow"],
    ["mountain","⛰️",""],
    ["volcano","🌋","eruption mountain nature"],
    ["mount_fuji","🗻","mount fuji mountain nature"],
    ["camping","🏕️",""],
    ["beach_with_umbrella","🏖️","beach with umbrella"],
    ["desert","🏜️",""],
    ["desert_island","🏝️","desert island"],
    ["national_park","🏞️","national park"],
    ["stadium","🏟️",""],
    ["classical_building","🏛️","classical building"],
    ["building_construction","🏗️","building construction crane"],
    ["bricks","🧱","brick clay mortar wall"],
    ["rock","🪨","boulder heavy solid stone tough"],
    ["wood","🪵","log lumber timber"],
    ["hut","🛖","home house roundhouse shelter yurt"],
    ["house_buildings","🏘️","houses house"],
    ["derelict_house_building","🏚️","derelict house home"],
    ["house","🏠","building country heart home ranch settle simple suburban suburbia where"],
    ["house_with_garden","🏡","house with garden building country heart home ranch settle simple suburban suburbia where"],
    ["office","🏢","building city cubical job"],
    ["post_office","🏣","japanese post office building"],
    ["european_post_office","🏤","post office building european"],
    ["hospital","🏥","building doctor medicine"],
    ["bank","🏦","building"],
    ["hotel","🏨","building"],
    ["love_hotel","🏩","love hotel building"],
    ["convenience_store","🏪","convenience store 24 building hours"],
    ["school","🏫","building"],
    ["department_store","🏬","department store building"],
    ["factory","🏭","building"],
    ["japanese_castle","🏯","japanese castle building"],
    ["european_castle","🏰","castle building european"],
    ["wedding","💒","chapel hitched nuptials romance"],
    ["tokyo_tower","🗼","tokyo tower"],
    ["statue_of_liberty","🗽","statue of liberty new ny nyc york"],
    ["church","⛪","bless chapel christian cross religion"],
    ["mosque","🕌","islam masjid muslim religion"],
    ["hindu_temple","🛕","hindu temple"],
    ["synagogue","🕍","jew jewish judaism religion temple"],
    ["shinto_shrine","⛩️","shinto shrine religion"],
    ["kaaba","🕋","hajj islam muslim religion umrah"],
    ["fountain","⛲",""],
    ["tent","⛺","camping"],
    ["foggy","🌁","fog"],
    ["night_with_stars","🌃","night with stars star"],
    ["cityscape","🏙️","city"],
    ["sunrise_over_mountains","🌄","sunrise over mountains morning sun"],
    ["sunrise","🌅","morning nature sun"],
    ["city_sunset","🌆","cityscape at dusk building city evening landscape sun sunset"],
    ["city_sunrise","🌇","sunset building dusk sun"],
    ["bridge_at_night","🌉","bridge at night"],
    ["hotsprings","♨️","hot springs steaming"],
    ["carousel_horse","🎠","carousel horse entertainment"],
    ["playground_slide","🛝","playground slide amusement park play playing sliding theme"],
    ["ferris_wheel","🎡","ferris wheel amusement park theme"],
    ["roller_coaster","🎢","roller coaster amusement park theme"],
    ["barber","💈","pole cut fresh haircut shave"],
    ["circus_tent","🎪","circus tent"],
    ["steam_locomotive","🚂","locomotive caboose engine railway steam train trains travel"],
    ["railway_car","🚃","railway car electric train tram travel trolleybus"],
    ["bullettrain_side","🚄","high-speed train railway shinkansen speed"],
    ["bullettrain_front","🚅","bullet train high-speed nose railway shinkansen speed travel"],
    ["train2","🚆","train arrived choo railway"],
    ["metro","🚇","subway travel"],
    ["light_rail","🚈","light rail arrived monorail railway"],
    ["station","🚉","railway train"],
    ["tram","🚊","trolleybus"],
    ["monorail","🚝","vehicle"],
    ["mountain_railway","🚞","mountain railway car trip"],
    ["train","🚋","tram car bus trolley trolleybus"],
    ["bus","🚌","school vehicle"],
    ["oncoming_bus","🚍","oncoming bus cars"],
    ["trolleybus","🚎","bus tram trolley"],
    ["minibus","🚐","bus drive van vehicle"],
    ["ambulance","🚑","emergency vehicle"],
    ["fire_engine","🚒","fire engine truck"],
    ["police_car","🚓","police car 5–0 cops patrol"],
    ["oncoming_police_car","🚔","oncoming police car"],
    ["taxi","🚕","cab cabbie car drive vehicle yellow"],
    ["oncoming_taxi","🚖","oncoming taxi cab cabbie cars drove hail yellow"],
    ["car","🚗","automobile driving vehicle","red_car"],
    ["oncoming_automobile","🚘","oncoming automobile car cars drove vehicle"],
    ["blue_car","🚙","sport utility vehicle car drive recreational sportutility"],
    ["pickup_truck","🛻","pickup truck automobile car flatbed pick-up transportation"],
    ["truck","🚚","delivery car drive vehicle"],
    ["articulated_lorry","🚛","articulated lorry car drive move semi truck vehicle"],
    ["tractor","🚜","vehicle"],
    ["racing_car","🏎️","racing car zoom"],
    ["racing_motorcycle","🏍️","motorcycle racing"],
    ["motor_scooter","🛵","motor scooter"],
    ["manual_wheelchair","🦽","manual wheelchair accessibility"],
    ["motorized_wheelchair","🦼","motorized wheelchair accessibility"],
    ["auto_rickshaw","🛺","auto rickshaw tuk"],
    ["bike","🚲","bicycle class cycle cycling cyclist gang ride spin spinning"],
    ["scooter","🛴","kick"],
    ["skateboard","🛹","board skate skater wheels"],
    ["roller_skate","🛼","roller skate blades skates sport"],
    ["busstop","🚏","bus stop"],
    ["motorway","🛣️","highway road"],
    ["railway_track","🛤️","railway track train"],
    ["oil_drum","🛢️","oil drum"],
    ["fuelpump","⛽","fuel pump diesel gas gasoline station"],
    ["wheel","🛞","car circle tire turn vehicle"],
    ["rotating_light","🚨","police car light alarm alert beacon emergency revolving siren"],
    ["traffic_light","🚥","horizontal traffic light intersection signal stop stoplight"],
    ["vertical_traffic_light","🚦","vertical traffic light drove intersection signal stop stoplight"],
    ["octagonal_sign","🛑","stop sign octagonal"],
    ["construction","🚧","barrier"],
    ["anchor","⚓","ship tool"],
    ["ring_buoy","🛟","ring buoy float life lifesaver preserver rescue safety save saver swim"],
    ["boat","⛵","resort sailing sea yacht","sailboat"],
    ["canoe","🛶","boat"],
    ["speedboat","🚤","billionaire boat lake luxury millionaire summer travel"],
    ["passenger_ship","🛳️","passenger ship"],
    ["ferry","⛴️","boat passenger"],
    ["motor_boat","🛥️","motor boat motorboat"],
    ["ship","🚢","boat passenger travel"],
    ["airplane","✈️","aeroplane fly flying jet plane travel"],
    ["small_airplane","🛩️","small airplane aeroplane plane"],
    ["airplane_departure","🛫","airplane departure aeroplane check-in departures plane"],
    ["airplane_arriving","🛬","airplane arrival aeroplane arrivals arriving landing plane"],
    ["parachute","🪂","hang-glide parasail skydive"],
    ["seat","💺","chair"],
    ["helicopter","🚁","copter roflcopter travel vehicle"],
    ["suspension_railway","🚟","suspension railway"],
    ["mountain_cableway","🚠","mountain cableway cable gondola lift ski"],
    ["aerial_tramway","🚡","aerial tramway cable car gondola ropeway"],
    ["satellite","🛰️","space"],
    ["rocket","🚀","launch rockets space travel"],
    ["flying_saucer","🛸","flying saucer aliens extra terrestrial ufo"],
    ["bellhop_bell","🛎️","bellhop bell hotel"],
    ["luggage","🧳","bag packing roller suitcase travel"],
    ["hourglass","⌛","done sand time timer"],
    ["hourglass_flowing_sand","⏳","hourglass not done flowing hours sand timer waiting yolo"],
    ["watch","⌚","clock time"],
    ["alarm_clock","⏰","alarm clock hours hrs late time waiting"],
    ["stopwatch","⏱️","clock time"],
    ["timer_clock","⏲️","timer clock"],
    ["mantelpiece_clock","🕰️","mantelpiece clock time"],
    ["clock12","🕛","twelve o’clock 12 12:00 clock time"],
    ["clock1230","🕧","twelve-thirty 12 12:30 30 clock thirty time twelve"],
    ["clock1","🕐","one o’clock 1 1:00 clock time"],
    ["clock130","🕜","one-thirty 1 1:30 30 clock one thirty time"],
    ["clock2","🕑","two o’clock 2 2:00 clock time"],
    ["clock230","🕝","two-thirty 2 2:30 30 clock thirty time two"],
    ["clock3","🕒","three o’clock 3 3:00 clock time"],
    ["clock330","🕞","three-thirty 3 30 3:30 clock thirty three time"],
    ["clock4","🕓","four o’clock 4 4:00 clock time"],
    ["clock430","🕟","four-thirty 30 4 4:30 clock four thirty time"],
    ["clock5","🕔","five o’clock 5 5:00 clock time"],
    ["clock530","🕠","five-thirty 30 5 5:30 clock five thirty time"],
    ["clock6","🕕","six o’clock 6 6:00 clock time"],
    ["clock630","🕡","six-thirty 30 6 6:30 clock six thirty"],
    ["clock7","🕖","seven o’clock 0 7 7:00 clock"],
    ["clock730","🕢","seven-thirty 30 7 7:30 clock seven thirty"],
    ["clock8","🕗","eight o’clock 8 8:00 clock time"],
    ["clock830","🕣","eight-thirty 30 8 8:30 clock eight thirty time"],
    ["clock9","🕘","nine o’clock 9 9:00 clock time"],
    ["clock930","🕤","nine-thirty 30 9 9:30 clock nine thirty time"],
    ["clock10","🕙","ten o’clock 0 10 10:00 clock"],
    ["clock1030","🕥","ten-thirty 10 10:30 30 clock ten thirty time"],
    ["clock11","🕚","eleven o’clock 11 11:00 clock time"],
    ["clock1130","🕦","eleven-thirty 11 11:30 30 clock eleven thirty time"],
    ["new_moon","🌑","new moon dark space"],
    ["waxing_crescent_moon","🌒","waxing crescent moon dreams space"],
    ["first_quarter_moon","🌓","first quarter moon space"],
    ["moon","🌔","waxing gibbous space","waxing_gibbous_moon"],
    ["full_moon","🌕","full moon space"],
    ["waning_gibbous_moon","🌖","waning gibbous moon space"],
    ["last_quarter_moon","🌗","last quarter moon space"],
    ["waning_crescent_moon","🌘","waning crescent moon space"],
    ["crescent_moon","🌙","crescent moon ramadan space"],
    ["new_moon_with_face","🌚","new moon face space"],
    ["first_quarter_moon_with_face","🌛","first quarter moon face space"],
    ["last_quarter_moon_with_face","🌜","last quarter moon face dreams"],
    ["thermometer","🌡️","weather"],
    ["sunny","☀️","sun bright rays space weather"],
    ["full_moon_with_face","🌝","full moon face bright"],
    ["sun_with_face","🌞","sun with face beach bright day heat shine sunny sunshine weather"],
    ["ringed_planet","🪐","ringed planet saturn saturnine"],
    ["star","⭐","astronomy medium stars white"],
    ["star2","🌟","glowing star glittery glow night shining sparkle win"],
    ["stars","🌠","shooting star falling night space"],
    ["milky_way","🌌","milky way space"],
    ["cloud","☁️","weather"],
    ["partly_sunny","⛅","sun behind cloud cloudy weather"],
    ["thunder_cloud_and_rain","⛈️","cloud with lightning and rain thunder thunderstorm"],
    ["mostly_sunny","🌤️","sun behind small cloud weather","sun_small_cloud"],
    ["barely_sunny","🌥️","sun behind large cloud weather","sun_behind_cloud"],
    ["partly_sunny_rain","🌦️","sun behind rain cloud weather","sun_behind_rain_cloud"],
    ["rain_cloud","🌧️","cloud with rain weather"],
    ["snow_cloud","🌨️","cloud with snow cold weather"],
    ["lightning","🌩️","cloud with weather","lightning_cloud"],
    ["tornado","🌪️","cloud weather whirlwind","tornado_cloud"],
    ["fog","🌫️","cloud weather"],
    ["wind_blowing_face","🌬️","wind face blow cloud"],
    ["cyclone","🌀","dizzy hurricane twister typhoon weather"],
    ["rainbow","🌈","gay genderqueer glbt glbtq lesbian lgbt lgbtq lgbtqia nature pride queer rain trans transgender weather"],
    ["closed_umbrella","🌂","closed umbrella clothing rain"],
    ["umbrella","☂️","clothing rain"],
    ["umbrella_with_rain_drops","☔","umbrella with rain drops clothing drop weather"],
    ["umbrella_on_ground","⛱️","umbrella on ground rain sun"],
    ["zap","⚡","high voltage danger electric electricity lightning nature thunder thunderbolt"],
    ["snowflake","❄️","cold snow weather"],
    ["snowman","☃️","cold man snow"],
    ["snowman_without_snow","⛄","snowman without snow cold man"],
    ["comet","☄️","space"],
    ["fire","🔥","af burn flame hot lit litaf tool"],
    ["droplet","💧","cold comic drop nature sad sweat tear water weather"],
    ["ocean","🌊","water wave nature surf surfer surfing"],
  ]],
  ["activity", [
    ["jack_o_lantern","🎃","jack-o-lantern celebration halloween jack lantern pumpkin"],
    ["christmas_tree","🎄","christmas tree celebration"],
    ["fireworks","🎆","boom celebration entertainment yolo"],
    ["sparkler","🎇","boom celebration fireworks sparkle"],
    ["firecracker","🧨","dynamite explosive fire fireworks light pop popping spark"],
    ["sparkles","✨","* magic sparkle star"],
    ["balloon","🎈","birthday celebrate celebration"],
    ["tada","🎉","party popper awesome birthday celebrate celebration excited hooray woohoo"],
    ["confetti_ball","🎊","confetti ball celebrate celebration party woohoo"],
    ["tanabata_tree","🎋","tanabata tree banner celebration japanese"],
    ["bamboo","🎍","pine decoration celebration japanese plant"],
    ["dolls","🎎","japanese celebration doll festival"],
    ["flags","🎏","carp streamer celebration"],
    ["wind_chime","🎐","wind chime bell celebration"],
    ["rice_scene","🎑","moon viewing ceremony celebration"],
    ["red_envelope","🧧","red envelope gift good hóngbāo lai luck money see"],
    ["ribbon","🎀","celebration"],
    ["gift","🎁","wrapped birthday bow box celebration christmas present surprise"],
    ["reminder_ribbon","🎗️","reminder ribbon celebration"],
    ["admission_tickets","🎟️","admission tickets ticket"],
    ["ticket","🎫","admission stub"],
    ["medal","🎖️","military award celebration"],
    ["trophy","🏆","champion champs prize slay sport victory win winning"],
    ["sports_medal","🏅","sports medal award gold winner"],
    ["first_place_medal","🥇","1st place medal first gold"],
    ["second_place_medal","🥈","2nd place medal second silver"],
    ["third_place_medal","🥉","3rd place medal bronze third"],
    ["soccer","⚽","ball football futbol sport"],
    ["baseball","⚾","ball sport"],
    ["softball","🥎","ball glove sports underarm"],
    ["basketball","🏀","ball hoop sport"],
    ["volleyball","🏐","ball game"],
    ["football","🏈","american ball bowl sport super"],
    ["rugby_football","🏉","rugby football ball sport"],
    ["tennis","🎾","ball racquet sport"],
    ["flying_disc","🥏","flying disc ultimate"],
    ["bowling","🎳","ball game sport strike"],
    ["cricket_bat_and_ball","🏏","cricket game ball bat"],
    ["field_hockey_stick_and_ball","🏑","field hockey ball game stick"],
    ["ice_hockey_stick_and_puck","🏒","ice hockey game puck stick"],
    ["lacrosse","🥍","ball goal sports stick"],
    ["table_tennis_paddle_and_ball","🏓","ping pong ball bat game paddle pingpong table tennis"],
    ["badminton_racquet_and_shuttlecock","🏸","badminton birdie game racquet shuttlecock"],
    ["boxing_glove","🥊","boxing glove"],
    ["martial_arts_uniform","🥋","martial arts uniform judo karate taekwondo"],
    ["goal_net","🥅","goal net"],
    ["golf","⛳","flag in hole sport"],
    ["ice_skate","⛸️","ice skate skating"],
    ["fishing_pole_and_fish","🎣","fishing pole entertainment fish sport"],
    ["diving_mask","🤿","diving mask scuba snorkeling"],
    ["running_shirt_with_sash","🎽","running shirt athletics sash"],
    ["ski","🎿","skis snow sport"],
    ["sled","🛷","luge sledge sleigh snow toboggan"],
    ["curling_stone","🥌","curling stone game rock"],
    ["dart","🎯","bullseye bull direct entertainment game hit target"],
    ["yo-yo","🪀","fluctuate toy"],
    ["kite","🪁","fly soar"],
    ["gun","🔫","water pistol handgun revolver tool weapon"],
    ["8ball","🎱","pool 8 ball billiard eight game"],
    ["crystal_ball","🔮","crystal ball fairy fairytale fantasy fortune future magic tale tool"],
    ["magic_wand","🪄","magic wand magician witch wizard"],
    ["video_game","🎮","video game controller entertainment"],
    ["joystick","🕹️","game video videogame"],
    ["slot_machine","🎰","slot machine casino gamble gambling game slots"],
    ["game_die","🎲","game die dice entertainment"],
    ["jigsaw","🧩","puzzle piece clue interlocking"],
    ["teddy_bear","🧸","teddy bear plaything plush stuffed toy"],
    ["pinata","🪅","piñata candy celebrate celebration cinco de festive mayo party pinada"],
    ["mirror_ball","🪩","mirror ball dance disco glitter party"],
    ["nesting_dolls","🪆","nesting dolls babooshka baboushka babushka doll matryoshka russia"],
    ["spades","♠️","spade suit card game"],
    ["hearts","♥️","heart suit card emotion game"],
    ["diamonds","♦️","diamond suit card game"],
    ["clubs","♣️","club suit card game"],
    ["chess_pawn","♟️","chess pawn dupe expendable"],
    ["black_joker","🃏","joker card game wildcard"],
    ["mahjong","🀄","red dragon game"],
    ["flower_playing_cards","🎴","flower playing cards card game japanese"],
    ["performing_arts","🎭","performing arts actor actress art entertainment mask theater theatre thespian"],
    ["frame_with_picture","🖼️","framed picture art frame museum painting"],
    ["art","🎨","artist palette artsy arty colorful creative entertainment museum painter painting"],
    ["thread","🧵","needle sewing spool string"],
    ["sewing_needle","🪡","sewing needle embroidery sew stitches sutures tailoring thread"],
    ["yarn","🧶","ball crochet knit"],
    ["knot","🪢","cord rope tangled tie twine twist"],
  ]],
  ["objects", [
    ["eyeglasses","👓","glasses clothing eye eyewear"],
    ["dark_sunglasses","🕶️","sunglasses dark eye eyewear glasses"],
    ["goggles","🥽","dive eye protection scuba swimming welding"],
    ["lab_coat","🥼","lab coat clothes doctor dr experiment jacket scientist white"],
    ["safety_vest","🦺","safety vest emergency"],
    ["necktie","👔","clothing employed serious shirt tie"],
    ["shirt","👕","t-shirt blue casual clothes clothing collar dressed shopping weekend","tshirt"],
    ["jeans","👖","blue casual clothes clothing denim dressed pants shopping trousers weekend"],
    ["scarf","🧣","bundle cold neck up"],
    ["gloves","🧤","hand"],
    ["coat","🧥","brr bundle cold jacket up"],
    ["socks","🧦","stocking"],
    ["dress","👗","clothes clothing dressed fancy shopping"],
    ["kimono","👘","clothing comfortable"],
    ["sari","🥻","clothing dress"],
    ["one-piece_swimsuit","🩱","one-piece swimsuit bathing suit"],
    ["briefs","🩲","bathing one-piece suit swimsuit underwear"],
    ["shorts","🩳","bathing pants suit swimsuit underwear"],
    ["bikini","👙","bathing beach clothing pool suit swim"],
    ["womans_clothes","👚","woman’s clothes blouse clothing collar dress dressed lady shirt shopping woman"],
    ["folding_hand_fan","🪭","folding hand fan clack clap cool cooling dance flirt flutter hot shy"],
    ["purse","👛","clothes clothing coin dress fancy handbag shopping"],
    ["handbag","👜","bag clothes clothing dress lady purse shopping"],
    ["pouch","👝","clutch bag clothes clothing dress handbag purse"],
    ["shopping_bags","🛍️","shopping bags bag hotel"],
    ["school_satchel","🎒","backpack backpacking bag bookbag education rucksack satchel school"],
    ["thong_sandal","🩴","thong sandal beach flip flop sandals shoe thongs zōri"],
    ["mans_shoe","👞","man’s brown clothes clothing feet foot kick man shoes shopping","shoe"],
    ["athletic_shoe","👟","running shoe athletic clothes clothing fast kick shoes shopping sneaker tennis"],
    ["hiking_boot","🥾","hiking boot backpacking brown camping outdoors shoe"],
    ["womans_flat_shoe","🥿","flat shoe ballet comfy flats slip-on slipper"],
    ["high_heel","👠","high-heeled shoe clothes clothing dress fashion heel heels shoes shopping stiletto woman"],
    ["sandal","👡","woman’s clothing shoe woman"],
    ["ballet_shoes","🩰","ballet shoes dance"],
    ["boot","👢","woman’s clothes clothing dress shoe shoes shopping woman"],
    ["hair_pick","🪮","hair pick afro comb groom"],
    ["crown","👑","clothing family king medieval queen royal royalty win"],
    ["womans_hat","👒","woman’s hat clothes clothing garden hats party woman"],
    ["tophat","🎩","top hat clothes clothing fancy formal magic"],
    ["mortar_board","🎓","graduation cap celebration clothing education hat scholar"],
    ["billed_cap","🧢","billed cap baseball bent dad hat"],
    ["military_helmet","🪖","military helmet army soldier war warrior"],
    ["helmet_with_white_cross","⛑️","rescue worker’s helmet aid cross face hat"],
    ["prayer_beads","📿","prayer beads clothing necklace religion"],
    ["lipstick","💄","cosmetics date makeup"],
    ["ring","💍","diamond engaged engagement married romance shiny sparkling wedding"],
    ["gem","💎","stone diamond engagement jewel money romance wedding"],
    ["mute","🔇","muted speaker quiet silent sound"],
    ["speaker","🔈","low volume soft sound"],
    ["sound","🔉","speaker medium volume"],
    ["loud_sound","🔊","speaker high volume loud music sound"],
    ["loudspeaker","📢","address communication loud public sound"],
    ["mega","📣","megaphone cheering sound"],
    ["postal_horn","📯","postal horn post"],
    ["bell","🔔","break church sound"],
    ["no_bell","🔕","bell with slash forbidden mute no not prohibited quiet silent sound"],
    ["musical_score","🎼","musical score music note"],
    ["musical_note","🎵","musical note music sound"],
    ["notes","🎶","musical music note sound"],
    ["studio_microphone","🎙️","studio microphone mic music"],
    ["level_slider","🎚️","level slider music"],
    ["control_knobs","🎛️","control knobs music"],
    ["microphone","🎤","karaoke mic music sing sound"],
    ["headphones","🎧","headphone earbud sound"],
    ["radio","📻","entertainment tbt video"],
    ["saxophone","🎷","instrument music sax"],
    ["trumpet","🎺","instrument music"],
    ["accordion","🪗","box concertina instrument music squeeze squeezebox"],
    ["guitar","🎸","instrument music strat"],
    ["musical_keyboard","🎹","musical keyboard instrument music piano"],
    ["violin","🎻","instrument music"],
    ["banjo","🪕","music stringed"],
    ["drum_with_drumsticks","🥁","drum drumsticks music"],
    ["long_drum","🪘","long drum beat conga instrument rhythm"],
    ["maracas","🪇","cha dance instrument music party percussion rattle shake shaker"],
    ["flute","🪈","band fife flautist instrument marching music orchestra piccolo pipe recorder woodwind"],
    ["harp","🪉","cupid instrument love music orchestra"],
    ["iphone","📱","mobile phone cell communication telephone"],
    ["calling","📲","mobile phone with arrow build call cell communication receive telephone"],
    ["phone","☎️","","telephone"],
    ["telephone_receiver","📞","telephone receiver communication phone voip"],
    ["pager","📟","communication"],
    ["fax","📠","machine communication"],
    ["battery","🔋",""],
    ["low_battery","🪫","low battery drained electronic energy power"],
    ["electric_plug","🔌","electric plug electricity"],
    ["computer","💻","laptop office pc personal"],
    ["desktop_computer","🖥️","desktop computer monitor"],
    ["printer","🖨️","computer"],
    ["keyboard","⌨️","computer"],
    ["three_button_mouse","🖱️","computer mouse"],
    ["trackball","🖲️","computer"],
    ["minidisc","💽","computer disk minidisk optical"],
    ["floppy_disk","💾","floppy disk computer"],
    ["cd","💿","optical disk blu-ray computer dvd"],
    ["dvd","📀","blu-ray cd computer disk optical"],
    ["abacus","🧮","calculation calculator"],
    ["movie_camera","🎥","movie camera bollywood cinema film hollywood record"],
    ["film_frames","🎞️","film frames cinema movie"],
    ["film_projector","📽️","film projector cinema movie video"],
    ["clapper","🎬","board action movie"],
    ["tv","📺","television video"],
    ["camera","📷","photo selfie snap tbt trip video"],
    ["camera_with_flash","📸","camera with flash video"],
    ["video_camera","📹","video camera camcorder tbt"],
    ["vhs","📼","videocassette old school tape vcr video"],
    ["mag","🔍","magnifying glass tilted left lab left-pointing science search tool"],
    ["mag_right","🔎","magnifying glass tilted right contact lab right-pointing science search tool"],
    ["candle","🕯️","light"],
    ["bulb","💡","light comic electric idea"],
    ["flashlight","🔦","electric light tool torch"],
    ["izakaya_lantern","🏮","red paper bar light restaurant","lantern"],
    ["diya_lamp","🪔","diya lamp light oil"],
    ["notebook_with_decorative_cover","📔","notebook with decorative cover book decorated education school writing"],
    ["closed_book","📕","closed book education"],
    ["book","📖","open education fantasy knowledge library novels reading","open_book"],
    ["green_book","📗","green book education fantasy library reading"],
    ["blue_book","📘","blue book education fantasy library reading"],
    ["orange_book","📙","orange book education fantasy library reading"],
    ["books","📚","book education fantasy knowledge library novels reading school study"],
    ["notebook","📓",""],
    ["ledger","📒","notebook"],
    ["page_with_curl","📃","page with curl document paper"],
    ["scroll","📜","paper"],
    ["page_facing_up","📄","page facing up document paper"],
    ["newspaper","📰","communication news paper"],
    ["rolled_up_newspaper","🗞️","rolled-up newspaper news paper rolled"],
    ["bookmark_tabs","📑","bookmark tabs mark marker"],
    ["bookmark","🔖","mark"],
    ["label","🏷️","tag"],
    ["coin","🪙","dollar euro gold metal money rich silver treasure"],
    ["moneybag","💰","money bag bank bet billion cash cost dollar gold million paid paying pot rich win"],
    ["yen","💴","banknote bank bill currency money note"],
    ["dollar","💵","banknote bank bill currency money note"],
    ["euro","💶","banknote 100 bank bill currency money note rich"],
    ["pound","💷","banknote bank bill billion cash currency money note pounds"],
    ["money_with_wings","💸","money with wings bank banknote bill billion cash dollar fly million note pay"],
    ["credit_card","💳","credit card bank cash charge money pay"],
    ["receipt","🧾","accounting bookkeeping evidence invoice proof"],
    ["chart","💹","increasing with yen bank currency graph growth market money rise trend upward"],
    ["email","✉️","e-mail letter","envelope"],
    ["e-mail","📧","email letter mail"],
    ["incoming_envelope","📨","incoming envelope delivering e-mail email letter mail receive sent"],
    ["envelope_with_arrow","📩","envelope with arrow communication down e-mail email letter mail outgoing send sent"],
    ["outbox_tray","📤","outbox tray box email letter mail sent"],
    ["inbox_tray","📥","inbox tray box email letter mail receive zero"],
    ["package","📦","box communication delivery parcel shipping"],
    ["mailbox","📫","closed with raised flag communication mail postbox"],
    ["mailbox_closed","📪","closed mailbox with lowered flag mail postbox"],
    ["mailbox_with_mail","📬","open mailbox with raised flag mail postbox"],
    ["mailbox_with_no_mail","📭","open mailbox with lowered flag mail postbox"],
    ["postbox","📮","mail mailbox"],
    ["ballot_box_with_ballot","🗳️","ballot box with"],
    ["pencil2","✏️","pencil"],
    ["black_nib","✒️","black nib pen"],
    ["lower_left_fountain_pen","🖋️","fountain pen"],
    ["lower_left_ballpoint_pen","🖊️","pen ballpoint"],
    ["lower_left_paintbrush","🖌️","paintbrush painting"],
    ["lower_left_crayon","🖍️","crayon"],
    ["memo","📝","communication media notes","pencil"],
    ["briefcase","💼","office"],
    ["file_folder","📁","file folder"],
    ["open_file_folder","📂","open file folder"],
    ["card_index_dividers","🗂️","card index dividers"],
    ["date","📅","calendar"],
    ["calendar","📆","tear-off"],
    ["spiral_note_pad","🗒️","spiral notepad note pad"],
    ["spiral_calendar_pad","🗓️","spiral calendar pad"],
    ["card_index","📇","card index old rolodex school"],
    ["chart_with_upwards_trend","📈","chart increasing data graph growth right trend up upward"],
    ["chart_with_downwards_trend","📉","chart decreasing data down downward graph negative trend"],
    ["bar_chart","📊","bar chart data graph"],
    ["clipboard","📋","do list notes"],
    ["pushpin","📌","collage pin"],
    ["round_pushpin","📍","round pushpin location map pin"],
    ["paperclip","📎",""],
    ["linked_paperclips","🖇️","linked paperclips link paperclip"],
    ["straight_ruler","📏","straight ruler angle edge math straightedge"],
    ["triangular_ruler","📐","triangular ruler angle math rule set slide triangle"],
    ["scissors","✂️","cut cutting paper tool"],
    ["card_file_box","🗃️","card file box"],
    ["file_cabinet","🗄️","file cabinet filing paper"],
    ["wastebasket","🗑️","can garbage trash waste"],
    ["lock","🔒","locked closed private"],
    ["unlock","🔓","unlocked cracked lock open"],
    ["lock_with_ink_pen","🔏","locked with pen ink lock nib privacy"],
    ["closed_lock_with_key","🔐","locked with key bike closed lock secure"],
    ["key","🔑","keys lock major password unlock"],
    ["old_key","🗝️","old key clue lock"],
    ["hammer","🔨","home improvement repairs tool"],
    ["axe","🪓","ax chop hatchet split wood"],
    ["pick","⛏️","hammer mining tool"],
    ["hammer_and_pick","⚒️","hammer and pick tool"],
    ["hammer_and_wrench","🛠️","hammer and wrench spanner tool"],
    ["dagger_knife","🗡️","dagger knife weapon"],
    ["crossed_swords","⚔️","crossed swords weapon"],
    ["bomb","💣","boom comic dangerous explosion hot"],
    ["boomerang","🪃","rebound repercussion weapon"],
    ["bow_and_arrow","🏹","bow and arrow archer archery sagittarius tool weapon zodiac"],
    ["shield","🛡️","weapon"],
    ["carpentry_saw","🪚","carpentry saw carpenter cut lumber tool trim"],
    ["wrench","🔧","home improvement spanner tool"],
    ["screwdriver","🪛","flathead handy screw tool"],
    ["nut_and_bolt","🔩","nut and bolt home improvement tool"],
    ["gear","⚙️","cog cogwheel tool"],
    ["compression","🗜️","clamp compress tool vice"],
    ["scales","⚖️","balance scale justice libra tool weight zodiac"],
    ["probing_cane","🦯","white cane accessibility blind probing"],
    ["link","🔗","links"],
    ["broken_chain","⛓️‍💥","broken chain break breaking cuffs freedom"],
    ["chains","⛓️","chain"],
    ["hook","🪝","catch crook curve ensnare point selling"],
    ["toolbox","🧰","box chest mechanic red tool"],
    ["magnet","🧲","attraction horseshoe magnetic negative positive shape u"],
    ["ladder","🪜","climb rung step"],
    ["shovel","🪏","bury dig garden hole plant scoop snow spade"],
    ["alembic","⚗️","chemistry tool"],
    ["test_tube","🧪","test tube chemist chemistry experiment lab science"],
    ["petri_dish","🧫","petri dish bacteria biologist biology culture lab"],
    ["dna","🧬","biologist evolution gene genetics life"],
    ["microscope","🔬","experiment lab science tool"],
    ["telescope","🔭","contact extraterrestrial science tool"],
    ["satellite_antenna","📡","satellite antenna aliens contact dish science"],
    ["syringe","💉","doctor flu medicine needle shot sick tool vaccination"],
    ["drop_of_blood","🩸","drop of blood bleed donation injury medicine menstruation"],
    ["pill","💊","doctor drugs medicated medicine pills sick vitamin"],
    ["adhesive_bandage","🩹","adhesive bandage"],
    ["crutch","🩼","aid cane disability help hurt injured mobility stick"],
    ["stethoscope","🩺","doctor heart medicine"],
    ["x-ray","🩻","bones doctor medical skeleton skull xray"],
    ["door","🚪","back closet front"],
    ["elevator","🛗","accessibility hoist lift"],
    ["mirror","🪞","makeup reflection reflector speculum"],
    ["window","🪟","air frame fresh opening transparent view"],
    ["bed","🛏️","hotel sleep"],
    ["couch_and_lamp","🛋️","couch and lamp hotel"],
    ["chair","🪑","seat sit"],
    ["toilet","🚽","bathroom"],
    ["plunger","🪠","cup force plumber poop suction toilet"],
    ["shower","🚿","water"],
    ["bathtub","🛁","bath"],
    ["mouse_trap","🪤","mouse trap bait cheese lure mousetrap snare"],
    ["razor","🪒","sharp shave"],
    ["lotion_bottle","🧴","lotion bottle moisturizer shampoo sunscreen"],
    ["safety_pin","🧷","safety pin diaper punk rock"],
    ["broom","🧹","cleaning sweeping witch"],
    ["basket","🧺","farming laundry picnic"],
    ["roll_of_paper","🧻","roll of paper toilet towels"],
    ["bucket","🪣","cask pail vat"],
    ["soap","🧼","bar bathing clean cleaning lather soapdish"],
    ["bubbles","🫧","bubble burp clean floating pearl soap underwater"],
    ["toothbrush","🪥","bathroom brush clean dental hygiene teeth toiletry"],
    ["sponge","🧽","absorbing cleaning porous soak"],
    ["fire_extinguisher","🧯","fire extinguisher extinguish quench"],
    ["shopping_trolley","🛒","shopping cart trolley"],
    ["smoking","🚬","cigarette"],
    ["coffin","⚰️","dead death vampire"],
    ["headstone","🪦","cemetery dead grave graveyard memorial rip tomb tombstone"],
    ["funeral_urn","⚱️","funeral urn ashes death"],
    ["nazar_amulet","🧿","nazar amulet bead blue charm evil-eye talisman"],
    ["hamsa","🪬","amulet fatima fortune guide hand mary miriam palm protect protection"],
    ["moyai","🗿","moai face statue stoneface travel"],
    ["placard","🪧","card demonstration notice picket plaque protest sign"],
    ["identification_card","🪪","identification card credentials document id license security"],
  ]],
  ["symbols", [
    ["atm","🏧","sign automated bank cash money teller"],
    ["put_litter_in_its_place","🚮","litter in bin sign litterbin"],
    ["potable_water","🚰","potable water drinking"],
    ["wheelchair","♿","symbol access handicap"],
    ["mens","🚹","men’s room bathroom lavatory man restroom toilet wc"],
    ["womens","🚺","women’s room bathroom lavatory restroom toilet wc woman"],
    ["restroom","🚻","bathroom lavatory toilet wc"],
    ["baby_symbol","🚼","baby symbol changing"],
    ["wc","🚾","water closet bathroom lavatory restroom toilet"],
    ["passport_control","🛂","passport control"],
    ["customs","🛃","packing"],
    ["baggage_claim","🛄","baggage claim arrived bags case checked journey packing plane ready travel trip"],
    ["left_luggage","🛅","left luggage baggage case locker"],
    ["warning","⚠️","caution"],
    ["children_crossing","🚸","children crossing child pedestrian traffic"],
    ["no_entry","⛔","no entry do fail forbidden not pass prohibited traffic"],
    ["no_entry_sign","🚫","prohibited entry forbidden no not smoke"],
    ["no_bicycles","🚳","no bicycles bicycle bike forbidden not prohibited"],
    ["no_smoking","🚭","no smoking forbidden not prohibited smoke"],
    ["do_not_litter","🚯","no littering forbidden litter not prohibited"],
    ["non-potable_water","🚱","non-potable water dry non-drinking prohibited"],
    ["no_pedestrians","🚷","no pedestrians forbidden not pedestrian prohibited"],
    ["no_mobile_phones","📵","no mobile phones cell forbidden not phone prohibited telephone"],
    ["underage","🔞","no one under eighteen 18 age forbidden not prohibited restriction"],
    ["radioactive_sign","☢️","radioactive sign"],
    ["biohazard_sign","☣️","biohazard sign"],
    ["arrow_up","⬆️","up arrow cardinal direction north"],
    ["arrow_upper_right","↗️","up-right arrow direction intercardinal northeast"],
    ["arrow_right","➡️","right arrow cardinal direction east"],
    ["arrow_lower_right","↘️","down-right arrow direction intercardinal southeast"],
    ["arrow_down","⬇️","down arrow cardinal direction south"],
    ["arrow_lower_left","↙️","down-left arrow direction intercardinal southwest"],
    ["arrow_left","⬅️","left arrow cardinal direction west"],
    ["arrow_upper_left","↖️","up-left arrow direction intercardinal northwest"],
    ["arrow_up_down","↕️","up-down arrow"],
    ["left_right_arrow","↔️","left-right arrow"],
    ["leftwards_arrow_with_hook","↩️","right arrow curving left"],
    ["arrow_right_hook","↪️","left arrow curving right"],
    ["arrow_heading_up","⤴️","right arrow curving up"],
    ["arrow_heading_down","⤵️","right arrow curving down"],
    ["arrows_clockwise","🔃","clockwise vertical arrows arrow refresh reload"],
    ["arrows_counterclockwise","🔄","counterclockwise arrows button again anticlockwise arrow deja refresh rewindershins vu"],
    ["back","🔙","arrow"],
    ["end","🔚","arrow"],
    ["on","🔛","on! arrow mark"],
    ["soon","🔜","arrow brb omw"],
    ["top","🔝","arrow homie up"],
    ["place_of_worship","🛐","place of worship pray religion"],
    ["atom_symbol","⚛️","atom symbol atheist"],
    ["om_symbol","🕉️","om hindu religion"],
    ["star_of_david","✡️","star of david jew jewish judaism religion"],
    ["wheel_of_dharma","☸️","wheel of dharma buddhist religion"],
    ["yin_yang","☯️","yin yang difficult lives religion tao taoist total yinyang"],
    ["latin_cross","✝️","latin cross christ christian religion"],
    ["orthodox_cross","☦️","orthodox cross christian religion"],
    ["star_and_crescent","☪️","star and crescent islam muslim ramadan religion"],
    ["peace_symbol","☮️","peace symbol healing peaceful"],
    ["menorah_with_nine_branches","🕎","menorah candelabrum candlestick hanukkah jewish judaism religion"],
    ["six_pointed_star","🔯","dotted six-pointed star fortune jewish judaism"],
    ["khanda","🪯","deg fateh khalsa religion sikh sikhism tegh"],
    ["aries","♈","horoscope ram zodiac"],
    ["taurus","♉","bull horoscope ox zodiac"],
    ["gemini","♊","horoscope twins zodiac"],
    ["cancer","♋","crab horoscope zodiac"],
    ["leo","♌","horoscope lion zodiac"],
    ["virgo","♍","horoscope zodiac"],
    ["libra","♎","balance horoscope justice scales zodiac"],
    ["scorpius","♏","scorpio horoscope scorpion zodiac"],
    ["sagittarius","♐","archer horoscope zodiac"],
    ["capricorn","♑","goat horoscope zodiac"],
    ["aquarius","♒","bearer horoscope water zodiac"],
    ["pisces","♓","fish horoscope zodiac"],
    ["ophiuchus","⛎","bearer serpent snake zodiac"],
    ["twisted_rightwards_arrows","🔀","shuffle tracks button arrow crossed"],
    ["repeat","🔁","button arrow clockwise"],
    ["repeat_one","🔂","repeat single button arrow clockwise once"],
    ["arrow_forward","▶️","play button arrow right triangle"],
    ["fast_forward","⏩","fast-forward button arrow double fast forward"],
    ["black_right_pointing_double_triangle_with_vertical_bar","⏭️","next track button arrow scene triangle"],
    ["black_right_pointing_triangle_with_double_vertical_bar","⏯️","play or pause button arrow right triangle"],
    ["arrow_backward","◀️","reverse button arrow left triangle"],
    ["rewind","⏪","fast reverse button arrow double"],
    ["black_left_pointing_double_triangle_with_vertical_bar","⏮️","last track button arrow previous scene triangle"],
    ["arrow_up_small","🔼","upwards button arrow red up"],
    ["arrow_double_up","⏫","fast up button arrow double"],
    ["arrow_down_small","🔽","downwards button arrow down red"],
    ["arrow_double_down","⏬","fast down button arrow double"],
    ["double_vertical_bar","⏸️","pause button bar double vertical"],
    ["black_square_for_stop","⏹️","stop button square"],
    ["black_circle_for_record","⏺️","record button circle"],
    ["eject","⏏️","button"],
    ["cinema","🎦","camera film movie"],
    ["low_brightness","🔅","dim button brightness low"],
    ["high_brightness","🔆","bright button brightness light"],
    ["signal_strength","📶","antenna bars bar cell communication mobile phone signal telephone"],
    ["wireless","🛜","broadband computer connectivity hotspot internet network router smartphone wi-fi wifi wlan"],
    ["vibration_mode","📳","vibration mode cell communication mobile phone telephone"],
    ["mobile_phone_off","📴","mobile phone off cell telephone"],
    ["female_sign","♀️","female sign woman"],
    ["male_sign","♂️","male sign man"],
    ["transgender_symbol","⚧️","transgender symbol"],
    ["heavy_multiplication_x","✖️","multiply cancel multiplication sign x ×"],
    ["heavy_plus_sign","➕","plus +"],
    ["heavy_minus_sign","➖","minus - heavy math sign −"],
    ["heavy_division_sign","➗","divide division heavy math sign ÷"],
    ["heavy_equals_sign","🟰","heavy equals sign answer equal equality math"],
    ["infinity","♾️","forever unbounded universal"],
    ["bangbang","‼️","double exclamation mark ! !! punctuation"],
    ["interrobang","⁉️","exclamation question mark ! !? ? punctuation"],
    ["question","❓","red mark ? punctuation"],
    ["grey_question","❔","white question mark ? outlined punctuation"],
    ["grey_exclamation","❕","white exclamation mark ! outlined punctuation"],
    ["exclamation","❗","red mark ! punctuation","heavy_exclamation_mark"],
    ["wavy_dash","〰️","wavy dash punctuation"],
    ["currency_exchange","💱","currency exchange bank money"],
    ["heavy_dollar_sign","💲","heavy dollar sign billion cash charge currency million money pay"],
    ["medical_symbol","⚕️","medical symbol aesculapius medicine staff","staff_of_aesculapius"],
    ["recycle","♻️","recycling symbol"],
    ["fleur_de_lis","⚜️","fleur-de-lis knights"],
    ["trident","🔱","emblem anchor poseidon ship tool"],
    ["name_badge","📛","name badge"],
    ["beginner","🔰","japanese symbol for chevron green leaf tool yellow"],
    ["o","⭕","hollow red circle heavy large"],
    ["white_check_mark","✅","check mark button checked checkmark complete completed done fixed tick ✓"],
    ["ballot_box_with_check","☑️","check box with ballot checked done off tick ✓"],
    ["heavy_check_mark","✔️","check mark checked checkmark done heavy tick ✓"],
    ["x","❌","cross mark cancel multiplication multiply ×"],
    ["negative_squared_cross_mark","❎","cross mark button multiplication multiply square x ×"],
    ["curly_loop","➰","curly loop curl"],
    ["loop","➿","double curly curl"],
    ["part_alternation_mark","〽️","part alternation mark"],
    ["eight_spoked_asterisk","✳️","eight-spoked asterisk *"],
    ["eight_pointed_black_star","✴️","eight-pointed star *"],
    ["sparkle","❇️","*"],
    ["copyright","©️","c"],
    ["registered","®️","r"],
    ["tm","™️","trade mark trademark"],
    ["splatter","🫟","drip holi ink liquid mess paint spill stain"],
    ["hash","#️⃣","keycap: # keycap"],
    ["keycap_star","*️⃣","keycap: * keycap"],
    ["zero","0️⃣","keycap: 0 keycap"],
    ["one","1️⃣","keycap: 1 keycap"],
    ["two","2️⃣","keycap: 2 keycap"],
    ["three","3️⃣","keycap: 3 keycap"],
    ["four","4️⃣","keycap: 4 keycap"],
    ["five","5️⃣","keycap: 5 keycap"],
    ["six","6️⃣","keycap: 6 keycap"],
    ["seven","7️⃣","keycap: 7 keycap"],
    ["eight","8️⃣","keycap: 8 keycap"],
    ["nine","9️⃣","keycap: 9 keycap"],
    ["keycap_ten","🔟","keycap: 10 keycap"],
    ["capital_abcd","🔠","input latin uppercase abcd letters"],
    ["abcd","🔡","input latin lowercase letters"],
    ["1234","🔢","input numbers"],
    ["symbols","🔣","input % & ♪ 〒"],
    ["abc","🔤","input latin letters alphabet"],
    ["a","🅰️","button (blood type) blood type"],
    ["ab","🆎","button (blood type) blood type"],
    ["b","🅱️","button (blood type) blood type"],
    ["cl","🆑","button"],
    ["cool","🆒","button"],
    ["free","🆓","button"],
    ["information_source","ℹ️","information i"],
    ["id","🆔","button identity"],
    ["m","Ⓜ️","circled circle"],
    ["new","🆕","button"],
    ["ng","🆖","button"],
    ["o2","🅾️","o button (blood type) blood type"],
    ["ok","🆗","button okay"],
    ["parking","🅿️","p button"],
    ["sos","🆘","button help"],
    ["up","🆙","up! button mark"],
    ["vs","🆚","button versus"],
    ["koko","🈁","japanese “here” button here katakana"],
    ["sa","🈂️","japanese “service charge” button charge katakana service"],
    ["u6708","🈷️","japanese “monthly amount” button amount ideograph monthly"],
    ["u6709","🈶","japanese “not free of charge” button charge ideograph not"],
    ["u6307","🈯","japanese “reserved” button ideograph reserved"],
    ["ideograph_advantage","🉐","japanese “bargain” button bargain ideograph"],
    ["u5272","🈹","japanese “discount” button discount ideograph"],
    ["u7121","🈚","japanese “free of charge” button charge free ideograph"],
    ["u7981","🈲","japanese “prohibited” button ideograph prohibited"],
    ["accept","🉑","japanese “acceptable” button acceptable ideograph"],
    ["u7533","🈸","japanese “application” button application ideograph"],
    ["u5408","🈴","japanese “passing grade” button grade ideograph passing"],
    ["u7a7a","🈳","japanese “vacancy” button ideograph vacancy"],
    ["congratulations","㊗️","japanese “congratulations” button ideograph"],
    ["secret","㊙️","japanese “secret” button ideograph"],
    ["u55b6","🈺","japanese “open for business” button business ideograph open"],
    ["u6e80","🈵","japanese “no vacancy” button ideograph no vacancy"],
    ["red_circle","🔴","red circle geometric"],
    ["large_orange_circle","🟠","orange circle"],
    ["large_yellow_circle","🟡","yellow circle"],
    ["large_green_circle","🟢","green circle"],
    ["large_blue_circle","🔵","blue circle geometric"],
    ["large_purple_circle","🟣","purple circle"],
    ["large_brown_circle","🟤","brown circle"],
    ["black_circle","⚫","black circle geometric"],
    ["white_circle","⚪","white circle geometric"],
    ["large_red_square","🟥","red square card penalty"],
    ["large_orange_square","🟧","orange square"],
    ["large_yellow_square","🟨","yellow square card penalty"],
    ["large_green_square","🟩","green square"],
    ["large_blue_square","🟦","blue square"],
    ["large_purple_square","🟪","purple square"],
    ["large_brown_square","🟫","brown square"],
    ["black_large_square","⬛","black large square geometric"],
    ["white_large_square","⬜","white large square geometric"],
    ["black_medium_square","◼️","black medium square geometric"],
    ["white_medium_square","◻️","white medium square geometric"],
    ["black_medium_small_square","◾","black medium-small square geometric"],
    ["white_medium_small_square","◽","white medium-small square geometric"],
    ["black_small_square","▪️","black small square geometric"],
    ["white_small_square","▫️","white small square geometric"],
    ["large_orange_diamond","🔶","large orange diamond geometric"],
    ["large_blue_diamond","🔷","large blue diamond geometric"],
    ["small_orange_diamond","🔸","small orange diamond geometric"],
    ["small_blue_diamond","🔹","small blue diamond geometric"],
    ["small_red_triangle","🔺","red triangle pointed up geometric"],
    ["small_red_triangle_down","🔻","red triangle pointed down geometric"],
    ["diamond_shape_with_a_dot_inside","💠","diamond with a dot comic geometric"],
    ["radio_button","🔘","radio button geometric"],
    ["white_square_button","🔳","white square button geometric outlined"],
    ["black_square_button","🔲","black square button geometric"],
  ]],
  ["flags", [
    ["checkered_flag","🏁","chequered flag checkered finish flags game race racing sport win"],
    ["triangular_flag_on_post","🚩","triangular flag construction golf post"],
    ["crossed_flags","🎌","crossed flags celebration cross japanese"],
    ["waving_black_flag","🏴","black flag waving"],
    ["waving_white_flag","🏳️","white flag waving"],
    ["rainbow-flag","🏳️‍🌈","rainbow flag bisexual gay genderqueer glbt glbtq lesbian lgbt lgbtq lgbtqia pride queer trans transgender"],
    ["transgender_flag","🏳️‍⚧️","transgender flag blue light pink white"],
    ["pirate_flag","🏴‍☠️","pirate flag jolly plunder roger treasure"],
    ["flag-ac","🇦🇨","flag: ascension island ac flag"],
    ["flag-ad","🇦🇩","flag: andorra ad flag"],
    ["flag-ae","🇦🇪","flag: united arab emirates ae flag"],
    ["flag-af","🇦🇫","flag: afghanistan af flag"],
    ["flag-ag","🇦🇬","flag: antigua & barbuda ag flag"],
    ["flag-ai","🇦🇮","flag: anguilla ai flag"],
    ["flag-al","🇦🇱","flag: albania al flag"],
    ["flag-am","🇦🇲","flag: armenia am flag"],
    ["flag-ao","🇦🇴","flag: angola ao flag"],
    ["flag-aq","🇦🇶","flag: antarctica aq flag"],
    ["flag-ar","🇦🇷","flag: argentina ar flag"],
    ["flag-as","🇦🇸","flag: american samoa as flag"],
    ["flag-at","🇦🇹","flag: austria at flag"],
    ["flag-au","🇦🇺","flag: australia au flag"],
    ["flag-aw","🇦🇼","flag: aruba aw flag"],
    ["flag-ax","🇦🇽","flag: åland islands ax flag"],
    ["flag-az","🇦🇿","flag: azerbaijan az flag"],
    ["flag-ba","🇧🇦","flag: bosnia & herzegovina ba flag"],
    ["flag-bb","🇧🇧","flag: barbados bb flag"],
    ["flag-bd","🇧🇩","flag: bangladesh bd flag"],
    ["flag-be","🇧🇪","flag: belgium be flag"],
    ["flag-bf","🇧🇫","flag: burkina faso bf flag"],
    ["flag-bg","🇧🇬","flag: bulgaria bg flag"],
    ["flag-bh","🇧🇭","flag: bahrain bh flag"],
    ["flag-bi","🇧🇮","flag: burundi bi flag"],
    ["flag-bj","🇧🇯","flag: benin bj flag"],
    ["flag-bl","🇧🇱","flag: st. barthélemy bl flag"],
    ["flag-bm","🇧🇲","flag: bermuda bm flag"],
    ["flag-bn","🇧🇳","flag: brunei bn flag"],
    ["flag-bo","🇧🇴","flag: bolivia bo flag"],
    ["flag-bq","🇧🇶","flag: caribbean netherlands bq flag"],
    ["flag-br","🇧🇷","flag: brazil br flag"],
    ["flag-bs","🇧🇸","flag: bahamas bs flag"],
    ["flag-bt","🇧🇹","flag: bhutan bt flag"],
    ["flag-bv","🇧🇻","flag: bouvet island bv flag"],
    ["flag-bw","🇧🇼","flag: botswana bw flag"],
    ["flag-by","🇧🇾","flag: belarus by flag"],
    ["flag-bz","🇧🇿","flag: belize bz flag"],
    ["flag-ca","🇨🇦","flag: canada ca flag"],
    ["flag-cc","🇨🇨","flag: cocos (keeling) islands cc flag"],
    ["flag-cd","🇨🇩","flag: congo - kinshasa cd flag"],
    ["flag-cf","🇨🇫","flag: central african republic cf flag"],
    ["flag-cg","🇨🇬","flag: congo - brazzaville cg flag"],
    ["flag-ch","🇨🇭","flag: switzerland ch flag"],
    ["flag-ci","🇨🇮","flag: côte d’ivoire ci flag"],
    ["flag-ck","🇨🇰","flag: cook islands ck flag"],
    ["flag-cl","🇨🇱","flag: chile cl flag"],
    ["flag-cm","🇨🇲","flag: cameroon cm flag"],
    ["cn","🇨🇳","flag: china flag","flag-cn"],
    ["flag-co","🇨🇴","flag: colombia co flag"],
    ["flag-cp","🇨🇵","flag: clipperton island cp flag"],
    ["flag-sark","🇨🇶","flag: sark cq flag"],
    ["flag-cr","🇨🇷","flag: costa rica cr flag"],
    ["flag-cu","🇨🇺","flag: cuba cu flag"],
    ["flag-cv","🇨🇻","flag: cape verde cv flag"],
    ["flag-cw","🇨🇼","flag: curaçao cw flag"],
    ["flag-cx","🇨🇽","flag: christmas island cx flag"],
    ["flag-cy","🇨🇾","flag: cyprus cy flag"],
    ["flag-cz","🇨🇿","flag: czechia cz flag"],
    ["de","🇩🇪","flag: germany flag","flag-de"],
    ["flag-dg","🇩🇬","flag: diego garcia dg flag"],
    ["flag-dj","🇩🇯","flag: djibouti dj flag"],
    ["flag-dk","🇩🇰","flag: denmark dk flag"],
    ["flag-dm","🇩🇲","flag: dominica dm flag"],
    ["flag-do","🇩🇴","flag: dominican republic do flag"],
    ["flag-dz","🇩🇿","flag: algeria dz flag"],
    ["flag-ea","🇪🇦","flag: ceuta & melilla ea flag"],
    ["flag-ec","🇪🇨","flag: ecuador ec flag"],
    ["flag-ee","🇪🇪","flag: estonia ee flag"],
    ["flag-eg","🇪🇬","flag: egypt eg flag"],
    ["flag-eh","🇪🇭","flag: western sahara eh flag"],
    ["flag-er","🇪🇷","flag: eritrea er flag"],
    ["es","🇪🇸","flag: spain flag","flag-es"],
    ["flag-et","🇪🇹","flag: ethiopia et flag"],
    ["flag-eu","🇪🇺","flag: european union eu flag"],
    ["flag-fi","🇫🇮","flag: finland fi flag"],
    ["flag-fj","🇫🇯","flag: fiji fj flag"],
    ["flag-fk","🇫🇰","flag: falkland islands fk flag"],
    ["flag-fm","🇫🇲","flag: micronesia fm flag"],
    ["flag-fo","🇫🇴","flag: faroe islands fo flag"],
    ["fr","🇫🇷","flag: france flag","flag-fr"],
    ["flag-ga","🇬🇦","flag: gabon ga flag"],
    ["gb","🇬🇧","flag: united kingdom flag","uk flag-gb"],
    ["flag-gd","🇬🇩","flag: grenada gd flag"],
    ["flag-ge","🇬🇪","flag: georgia ge flag"],
    ["flag-gf","🇬🇫","flag: french guiana gf flag"],
    ["flag-gg","🇬🇬","flag: guernsey gg flag"],
    ["flag-gh","🇬🇭","flag: ghana gh flag"],
    ["flag-gi","🇬🇮","flag: gibraltar gi flag"],
    ["flag-gl","🇬🇱","flag: greenland gl flag"],
    ["flag-gm","🇬🇲","flag: gambia gm flag"],
    ["flag-gn","🇬🇳","flag: guinea gn flag"],
    ["flag-gp","🇬🇵","flag: guadeloupe gp flag"],
    ["flag-gq","🇬🇶","flag: equatorial guinea gq flag"],
    ["flag-gr","🇬🇷","flag: greece gr flag"],
    ["flag-gs","🇬🇸","flag: south georgia & sandwich islands gs flag"],
    ["flag-gt","🇬🇹","flag: guatemala gt flag"],
    ["flag-gu","🇬🇺","flag: guam gu flag"],
    ["flag-gw","🇬🇼","flag: guinea-bissau gw flag"],
    ["flag-gy","🇬🇾","flag: guyana gy flag"],
    ["flag-hk","🇭🇰","flag: hong kong sar china hk flag"],
    ["flag-hm","🇭🇲","flag: heard & mcdonald islands hm flag"],
    ["flag-hn","🇭🇳","flag: honduras hn flag"],
    ["flag-hr","🇭🇷","flag: croatia hr flag"],
    ["flag-ht","🇭🇹","flag: haiti ht flag"],
    ["flag-hu","🇭🇺","flag: hungary hu flag"],
    ["flag-ic","🇮🇨","flag: canary islands ic flag"],
    ["flag-id","🇮🇩","flag: indonesia id flag"],
    ["flag-ie","🇮🇪","flag: ireland ie flag"],
    ["flag-il","🇮🇱","flag: israel il flag"],
    ["flag-im","🇮🇲","flag: isle of man im flag"],
    ["flag-in","🇮🇳","flag: india in flag"],
    ["flag-io","🇮🇴","flag: british indian ocean territory io flag"],
    ["flag-iq","🇮🇶","flag: iraq iq flag"],
    ["flag-ir","🇮🇷","flag: iran ir flag"],
    ["flag-is","🇮🇸","flag: iceland is flag"],
    ["it","🇮🇹","flag: italy flag","flag-it"],
    ["flag-je","🇯🇪","flag: jersey je flag"],
    ["flag-jm","🇯🇲","flag: jamaica jm flag"],
    ["flag-jo","🇯🇴","flag: jordan jo flag"],
    ["jp","🇯🇵","flag: japan flag","flag-jp"],
    ["flag-ke","🇰🇪","flag: kenya ke flag"],
    ["flag-kg","🇰🇬","flag: kyrgyzstan kg flag"],
    ["flag-kh","🇰🇭","flag: cambodia kh flag"],
    ["flag-ki","🇰🇮","flag: kiribati ki flag"],
    ["flag-km","🇰🇲","flag: comoros km flag"],
    ["flag-kn","🇰🇳","flag: st. kitts & nevis kn flag"],
    ["flag-kp","🇰🇵","flag: north korea kp flag"],
    ["kr","🇰🇷","flag: south korea flag","flag-kr"],
    ["flag-kw","🇰🇼","flag: kuwait kw flag"],
    ["flag-ky","🇰🇾","flag: cayman islands ky flag"],
    ["flag-kz","🇰🇿","flag: kazakhstan kz flag"],
    ["flag-la","🇱🇦","flag: laos la flag"],
    ["flag-lb","🇱🇧","flag: lebanon lb flag"],
    ["flag-lc","🇱🇨","flag: st. lucia lc flag"],
    ["flag-li","🇱🇮","flag: liechtenstein li flag"],
    ["flag-lk","🇱🇰","flag: sri lanka lk flag"],
    ["flag-lr","🇱🇷","flag: liberia lr flag"],
    ["flag-ls","🇱🇸","flag: lesotho ls flag"],
    ["flag-lt","🇱🇹","flag: lithuania lt flag"],
    ["flag-lu","🇱🇺","flag: luxembourg lu flag"],
    ["flag-lv","🇱🇻","flag: latvia lv flag"],
    ["flag-ly","🇱🇾","flag: libya ly flag"],
    ["flag-ma","🇲🇦","flag: morocco ma flag"],
    ["flag-mc","🇲🇨","flag: monaco mc flag"],
    ["flag-md","🇲🇩","flag: moldova md flag"],
    ["flag-me","🇲🇪","flag: montenegro me flag"],
    ["flag-mf","🇲🇫","flag: st. martin mf flag"],
    ["flag-mg","🇲🇬","flag: madagascar mg flag"],
    ["flag-mh","🇲🇭","flag: marshall islands mh flag"],
    ["flag-mk","🇲🇰","flag: north macedonia mk flag"],
    ["flag-ml","🇲🇱","flag: mali ml flag"],
    ["flag-mm","🇲🇲","flag: myanmar (burma) mm flag"],
    ["flag-mn","🇲🇳","flag: mongolia mn flag"],
    ["flag-mo","🇲🇴","flag: macao sar china mo flag"],
    ["flag-mp","🇲🇵","flag: northern mariana islands mp flag"],
    ["flag-mq","🇲🇶","flag: martinique mq flag"],
    ["flag-mr","🇲🇷","flag: mauritania mr flag"],
    ["flag-ms","🇲🇸","flag: montserrat ms flag"],
    ["flag-mt","🇲🇹","flag: malta mt flag"],
    ["flag-mu","🇲🇺","flag: mauritius mu flag"],
    ["flag-mv","🇲🇻","flag: maldives mv flag"],
    ["flag-mw","🇲🇼","flag: malawi mw flag"],
    ["flag-mx","🇲🇽","flag: mexico mx flag"],
    ["flag-my","🇲🇾","flag: malaysia my flag"],
    ["flag-mz","🇲🇿","flag: mozambique mz flag"],
    ["flag-na","🇳🇦","flag: namibia na flag"],
    ["flag-nc","🇳🇨","flag: new caledonia nc flag"],
    ["flag-ne","🇳🇪","flag: niger ne flag"],
    ["flag-nf","🇳🇫","flag: norfolk island nf flag"],
    ["flag-ng","🇳🇬","flag: nigeria ng flag"],
    ["flag-ni","🇳🇮","flag: nicaragua ni flag"],
    ["flag-nl","🇳🇱","flag: netherlands nl flag"],
    ["flag-no","🇳🇴","flag: norway no flag"],
    ["flag-np","🇳🇵","flag: nepal np flag"],
    ["flag-nr","🇳🇷","flag: nauru nr flag"],
    ["flag-nu","🇳🇺","flag: niue nu flag"],
    ["flag-nz","🇳🇿","flag: new zealand nz flag"],
    ["flag-om","🇴🇲","flag: oman om flag"],
    ["flag-pa","🇵🇦","flag: panama pa flag"],
    ["flag-pe","🇵🇪","flag: peru pe flag"],
    ["flag-pf","🇵🇫","flag: french polynesia pf flag"],
    ["flag-pg","🇵🇬","flag: papua new guinea pg flag"],
    ["flag-ph","🇵🇭","flag: philippines ph flag"],
    ["flag-pk","🇵🇰","flag: pakistan pk flag"],
    ["flag-pl","🇵🇱","flag: poland pl flag"],
    ["flag-pm","🇵🇲","flag: st. pierre & miquelon pm flag"],
    ["flag-pn","🇵🇳","flag: pitcairn islands pn flag"],
    ["flag-pr","🇵🇷","flag: puerto rico pr flag"],
    ["flag-ps","🇵🇸","flag: palestinian territories ps flag"],
    ["flag-pt","🇵🇹","flag: portugal pt flag"],
    ["flag-pw","🇵🇼","flag: palau pw flag"],
    ["flag-py","🇵🇾","flag: paraguay py flag"],
    ["flag-qa","🇶🇦","flag: qatar qa flag"],
    ["flag-re","🇷🇪","flag: réunion re flag"],
    ["flag-ro","🇷🇴","flag: romania ro flag"],
    ["flag-rs","🇷🇸","flag: serbia rs flag"],
    ["ru","🇷🇺","flag: russia flag","flag-ru"],
    ["flag-rw","🇷🇼","flag: rwanda rw flag"],
    ["flag-sa","🇸🇦","flag: saudi arabia sa flag"],
    ["flag-sb","🇸🇧","flag: solomon islands sb flag"],
    ["flag-sc","🇸🇨","flag: seychelles sc flag"],
    ["flag-sd","🇸🇩","flag: sudan sd flag"],
    ["flag-se","🇸🇪","flag: sweden se flag"],
    ["flag-sg","🇸🇬","flag: singapore sg flag"],
    ["flag-sh","🇸🇭","flag: st. helena sh flag"],
    ["flag-si","🇸🇮","flag: slovenia si flag"],
    ["flag-sj","🇸🇯","flag: svalbard & jan mayen sj flag"],
    ["flag-sk","🇸🇰","flag: slovakia sk flag"],
    ["flag-sl","🇸🇱","flag: sierra leone sl flag"],
    ["flag-sm","🇸🇲","flag: san marino sm flag"],
    ["flag-sn","🇸🇳","flag: senegal sn flag"],
    ["flag-so","🇸🇴","flag: somalia so flag"],
    ["flag-sr","🇸🇷","flag: suriname sr flag"],
    ["flag-ss","🇸🇸","flag: south sudan ss flag"],
    ["flag-st","🇸🇹","flag: são tomé & príncipe st flag"],
    ["flag-sv","🇸🇻","flag: el salvador sv flag"],
    ["flag-sx","🇸🇽","flag: sint maarten sx flag"],
    ["flag-sy","🇸🇾","flag: syria sy flag"],
    ["flag-sz","🇸🇿","flag: eswatini sz flag"],
    ["flag-ta","🇹🇦","flag: tristan da cunha ta flag"],
    ["flag-tc","🇹🇨","flag: turks & caicos islands tc flag"],
    ["flag-td","🇹🇩","flag: chad td flag"],
    ["flag-tf","🇹🇫","flag: french southern territories tf flag"],
    ["flag-tg","🇹🇬","flag: togo tg flag"],
    ["flag-th","🇹🇭","flag: thailand th flag"],
    ["flag-tj","🇹🇯","flag: tajikistan tj flag"],
    ["flag-tk","🇹🇰","flag: tokelau tk flag"],
    ["flag-tl","🇹🇱","flag: timor-leste tl flag"],
    ["flag-tm","🇹🇲","flag: turkmenistan tm flag"],
    ["flag-tn","🇹🇳","flag: tunisia tn flag"],
    ["flag-to","🇹🇴","flag: tonga to flag"],
    ["flag-tr","🇹🇷","flag: türkiye tr flag"],
    ["flag-tt","🇹🇹","flag: trinidad & tobago tt flag"],
    ["flag-tv","🇹🇻","flag: tuvalu tv flag"],
    ["flag-tw","🇹🇼","flag: taiwan tw flag"],
    ["flag-tz","🇹🇿","flag: tanzania tz flag"],
    ["flag-ua","🇺🇦","flag: ukraine ua flag"],
    ["flag-ug","🇺🇬","flag: uganda ug flag"],
    ["flag-um","🇺🇲","flag: u.s. outlying islands um flag"],
    ["flag-un","🇺🇳","flag: united nations un flag"],
    ["us","🇺🇸","flag: united states flag","flag-us"],
    ["flag-uy","🇺🇾","flag: uruguay uy flag"],
    ["flag-uz","🇺🇿","flag: uzbekistan uz flag"],
    ["flag-va","🇻🇦","flag: vatican city va flag"],
    ["flag-vc","🇻🇨","flag: st. vincent & grenadines vc flag"],
    ["flag-ve","🇻🇪","flag: venezuela ve flag"],
    ["flag-vg","🇻🇬","flag: british virgin islands vg flag"],
    ["flag-vi","🇻🇮","flag: u.s. virgin islands vi flag"],
    ["flag-vn","🇻🇳","flag: vietnam vn flag"],
    ["flag-vu","🇻🇺","flag: vanuatu vu flag"],
    ["flag-wf","🇼🇫","flag: wallis & futuna wf flag"],
    ["flag-ws","🇼🇸","flag: samoa ws flag"],
    ["flag-xk","🇽🇰","flag: kosovo xk flag"],
    ["flag-ye","🇾🇪","flag: yemen ye flag"],
    ["flag-yt","🇾🇹","flag: mayotte yt flag"],
    ["flag-za","🇿🇦","flag: south africa za flag"],
    ["flag-zm","🇿🇲","flag: zambia zm flag"],
    ["flag-zw","🇿🇼","flag: zimbabwe zw flag"],
    ["flag-england","🏴󠁧󠁢󠁥󠁮󠁧󠁿","flag: england flag gbeng"],
    ["flag-scotland","🏴󠁧󠁢󠁳󠁣󠁴󠁿","flag: scotland flag gbsct"],
    ["flag-wales","🏴󠁧󠁢󠁷󠁬󠁳󠁿","flag: wales flag gbwls"],
  ]],
];
